// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"cjbOo":[function(require,module,exports,__globalThis) {
var _preact = require("preact");
var _utils = require("../utils");
var _landingPage = require("./LandingPage");
(0, _utils.ping)();
window.addEventListener("load", ()=>{
    (0, _preact.render)((0, _preact.h)((0, _landingPage.LandingPage), null), document.body);
});

},{"preact":"7Pucd","../utils":"8FsEW","./LandingPage":"3jsEl"}],"7Pucd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Component", ()=>x);
parcelHelpers.export(exports, "Fragment", ()=>k);
parcelHelpers.export(exports, "cloneElement", ()=>K);
parcelHelpers.export(exports, "createContext", ()=>Q);
parcelHelpers.export(exports, "createElement", ()=>_);
parcelHelpers.export(exports, "createRef", ()=>b);
parcelHelpers.export(exports, "h", ()=>_);
parcelHelpers.export(exports, "hydrate", ()=>J);
parcelHelpers.export(exports, "isValidElement", ()=>t);
parcelHelpers.export(exports, "options", ()=>l);
parcelHelpers.export(exports, "render", ()=>G);
parcelHelpers.export(exports, "toChildArray", ()=>H);
var n, l, u, t, i, r, o, e, f, c, s, a, h, p = {}, v = [], y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, w = Array.isArray;
function d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function _(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return m(l, e, i, r, null);
}
function m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != l.vnode && l.vnode(e), e;
}
function b() {
    return {
        current: null
    };
}
function k(n) {
    return n.children;
}
function x(n, l) {
    this.props = n, this.context = l;
}
function S(n, l) {
    if (null == l) return n.__ ? S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? S(n) : null;
}
function C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return C(n);
    }
}
function M(n) {
    (!n.__d && (n.__d = !0) && i.push(n) && !$.__r++ || r != l.debounceRendering) && ((r = l.debounceRendering) || o)($);
}
function $() {
    for(var n, u, t, r, o, f, c, s = 1; i.length;)i.length > s && i.sort(e), n = i.shift(), s = i.length, n.__d && (t = void 0, r = void 0, o = (r = (u = n).__v).__e, f = [], c = [], u.__P && ((t = d({}, r)).__v = r.__v + 1, l.vnode && l.vnode(t), O(u.__P, t, r, u.__n, u.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? S(r) : o, !!(32 & r.__u), c), t.__v = r.__v, t.__.__k[t.__i] = t, N(f, t, c), r.__e = r.__ = null, t.__e != o && C(t)));
    $.__r = 0;
}
function I(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, w, d, g, _, m = t && t.__k || v, b = l.length;
    for(f = P(u, l, m, f, b), a = 0; a < b; a++)null != (y = u.__k[a]) && (h = -1 == y.__i ? p : m[y.__i] || p, y.__i = a, g = O(n, y, h, i, r, o, e, f, c, s), w = y.__e, y.ref && h.ref != y.ref && (h.ref && B(h.ref, null, y), s.push(y.ref, y.__c || w, y)), null == d && null != w && (d = w), (_ = !!(4 & y.__u)) || h.__k === y.__k ? f = A(y, f, n, _) : "function" == typeof y.type && void 0 !== g ? f = g : w && (f = w.nextSibling), y.__u &= -7);
    return u.__e = d, f;
}
function P(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? (f = r + h, (o = n.__k[r] = "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? m(null, o, null, null, null) : w(o) ? m(k, {
        children: o
    }, null, null, null) : null == o.constructor && o.__b > 0 ? m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o).__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = S(e)), D(e, e));
    return t;
}
function A(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = A(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = S(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function H(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (w(n) ? n.some(function(n) {
        H(n, l);
    }) : l.push(n)), l;
}
function L(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == n.key || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || y.test(l) ? u : u + "px";
}
function j(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace(f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = c, n.addEventListener(l, r ? a : s, r)) : n.removeEventListener(l, r ? a : s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = c++;
            else if (u.t < t.u) return;
            return t(l.event ? l.event(u) : u);
        }
    };
}
function O(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, $, P, A, H, L, T, j = u.type;
    if (null != u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = l.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new x(b, M), h.constructor = j, h.render = E), C && C.sub(h), h.props = b, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = d({}, h.__s)), d(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M) || u.__v == t.__v) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = l.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = d(d({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === k && null == a.key && (L = V(a.props.children)), f = I(n, w(L) ? L : [
            L
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(T = o.length; T--;)g(o[T]);
                z(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || z(u);
        l.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = q(t.__e, u, t, i, r, o, e, c, s);
    return (a = l.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function z(n) {
    n && n.__c && (n.__c.__e = !0), n && n.__k && n.__k.forEach(z);
}
function N(n, u, t) {
    for(var i = 0; i < t.length; i++)B(t[i], t[++i], t[++i]);
    l.__c && l.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            l.__e(n, u.__v);
        }
    });
}
function V(n) {
    return "object" != typeof n || null == n || n.__b && n.__b > 0 ? n : w(n) ? n.map(V) : d({}, n);
}
function q(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, d, _, m, b = i.props, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((d = e[a]) && "setAttribute" in d == !!x && (x ? d.localName == x : 3 == d.nodeType)) {
            u = d, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && (l.__m && l.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && n.call(u.childNodes), b = i.props || p, !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(d = u.attributes[a]).name] = d.value;
        for(a in b)if (d = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = d;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            j(u, a, null, d, o);
        }
        for(a in k)d = k[a], "children" == a ? y = d : "dangerouslySetInnerHTML" == a ? h = d : "value" == a ? _ = d : "checked" == a ? m = d : c && "function" != typeof d || b[a] === d || j(u, a, d, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), I("template" == t.type ? u.content : u, w(y) ? y : [
            y
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && S(i, 0), c, s), null != e) for(a = e.length; a--;)g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && j(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && j(u, a, m, b[a], o));
    }
    return u;
}
function B(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        l.__e(n, t);
    }
}
function D(n, u, t) {
    var i, r;
    if (l.unmount && l.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || B(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            l.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && D(i[r], u, t || "function" != typeof n.type);
    t || g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function E(n, l, u) {
    return this.constructor(n, u);
}
function G(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), l.__ && l.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], O(t, u = (!r && i || t).__k = _(k, null, [
        u
    ]), o || p, p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), N(e, u, f);
}
function J(n, l) {
    G(n, l, J);
}
function K(l, u, t) {
    var i, r, o, e, f = d({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : t), m(l.type, f, i || l.key, r || l.ref, null);
}
function Q(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
n = v.slice, l = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, u = 0, t = function(n) {
    return null != n && null == n.constructor;
}, x.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = d({}, this.state), "function" == typeof n && (n = n(d({}, u), this.props)), n && d(u, n), null != n && this.__v && (l && this._sb.push(l), M(this));
}, x.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), M(this));
}, x.prototype.render = k, i = [], o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $.__r = 0, f = /(PointerCapture)$|Capture$/i, c = 0, s = F(!1), a = F(!0), h = 0;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"3OcMv":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"8FsEW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ping", ()=>ping);
var _fingerprint = require("./fingerprint");
var _hash = require("./hash");
var _typeGuards = require("./typeGuards");
var _visitorPing = require("./visitor-ping");
var _visitorStorage = require("./visitor-storage");
const tryOrEmpty = (fn)=>(...args)=>{
        try {
            const result = fn(...args);
            if ((0, _typeGuards.isPromiseLike)(result)) return result.then((v)=>v, (error)=>`${error}`);
            return result;
        } catch (e) {
            return `${e}`;
        }
    };
async function ping() {
    let start = Date.now();
    const fp = await (0, _fingerprint.createFingerprint)(tryOrEmpty, (0, _hash.hash));
    const visitorId = (0, _visitorStorage.getVisitorId)();
    const elapsed = Date.now() - start;
    (0, _visitorPing.ping1)({
        browserHash: fp.browserHash,
        visitorId,
        elapsed
    });
    document.addEventListener("visibilitychange", ()=>{
        const type = document.hidden ? "unload" : "review";
        if (type === "review") start = Date.now();
        const elapsed = type == "unload" ? Date.now() - start : 0;
        (0, _visitorPing.ping1)({
            browserHash: fp.browserHash,
            visitorId,
            elapsed,
            type
        });
    });
    const done = Date.now();
    console.log(`Created fingerprint in ${done - start}ms`);
}

},{"./fingerprint":"d2kDT","./hash":"kzviu","./typeGuards":"1uMWY","./visitor-ping":"hnpU2","./visitor-storage":"7bO3N","@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"d2kDT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "createFingerprint", ()=>createFingerprint);
var _canvas = require("./canvas");
var _math = require("./math");
var _timezone = require("./timezone");
var _hardwareConcurrency = require("./hardwareConcurrency");
var _deviceMemory = require("./deviceMemory");
var _webgl = require("./webgl");
var _vendorFlavors = require("./vendorFlavors");
var _languages = require("./languages");
var _mediaMatches = require("./mediaMatches");
var _supportedMediaTypes = require("./supportedMediaTypes");
var _screen = require("./screen");
var _nativeNavigatorFunctions = require("./nativeNavigatorFunctions");
var _permissions = require("./permissions");
var _vendor = require("./vendor");
var _userAgent = require("./user-agent");
const noop = (fn)=>fn;
async function _create(wrap = noop) {
    const { widthDiff, heightDiff } = wrap((0, _screen.getScreenDiff))();
    const { height, width } = wrap((0, _screen.getScreenDimentions))();
    const [permissions, canvas] = await Promise.all([
        wrap((0, _permissions.getPermissions))(),
        wrap((0, _canvas.getCanvasFingerprint))()
    ]);
    return {
        canvas,
        math: wrap((0, _math.getMathFingerprint))(),
        timezone: wrap((0, _timezone.getTimezone))(),
        hardwareConcurrency: wrap((0, _hardwareConcurrency.getHardwareConcurrency))(),
        deviceMemory: wrap((0, _deviceMemory.getDeviceMemory))(),
        webglInfo: wrap((0, _webgl.getWebGLInfo))(),
        vendorFlavors: wrap((0, _vendorFlavors.getVendorFlavors))(),
        languages: wrap((0, _languages.getLanguages))(),
        mediaMatches: wrap((0, _mediaMatches.getMediaMatches))(),
        supportedAudioTypes: wrap((0, _supportedMediaTypes.getSupportedAudioTypes))(),
        supportedVideoTypes: wrap((0, _supportedMediaTypes.getSupportedVideoTypes))(),
        screenWidthDiff: widthDiff,
        screenHeightDiff: heightDiff,
        computedHeight: height,
        computedWidth: width,
        nativeNavigatorFunctions: wrap((0, _nativeNavigatorFunctions.getNativeNavigatorFunctions))(),
        vendor: wrap((0, _vendor.getVendor))(),
        permissions,
        userAgent: wrap((0, _userAgent.getUserAgent))()
    };
}
async function createFingerprint(wrap = noop, hash) {
    const fp = await _create(wrap);
    return {
        ...fp,
        browserHash: hash ? hash(fp) : ""
    };
}

},{"./canvas":"5FPwI","./math":"4wE2H","./timezone":"2evtl","./hardwareConcurrency":"imzAa","./deviceMemory":"aFGAa","./webgl":"3pjBf","./vendorFlavors":"bdzaw","./languages":"1nPmy","./mediaMatches":"gOBq4","./supportedMediaTypes":"eyjOo","./screen":"4Xj9y","./nativeNavigatorFunctions":"32uyi","./permissions":"740dl","./vendor":"iyBLw","./user-agent":"lu85g","@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"5FPwI":[function(require,module,exports,__globalThis) {
// https://github.com/fingerprintjs/fingerprintjs/blob/v3.3.2/src/sources/canvas.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCanvasFingerprint", ()=>getCanvasFingerprint);
var _utils = require("./utils");
function getCanvasFingerprint() {
    const ua = navigator.userAgent;
    if (ua.match(/;\s?Android\s[\d|\\.]+;/)) return Promise.resolve(ua);
    return new Promise((resolve)=>{
        (0, _utils.rafOrTimeout)(()=>{
            const canvasFingerPrint = getCanvasFingerprintSync();
            resolve(canvasFingerPrint);
        });
    });
}
// https://www.browserleaks.com/canvas#how-does-it-work
function getCanvasFingerprintSync() {
    const [canvas, context] = makeCanvasContext();
    if (!isSupported(canvas, context)) return {
        winding: false,
        geometry: "",
        text: ""
    };
    return {
        winding: doesSupportWinding(context),
        geometry: makeGeometryImage(canvas, context),
        // Text is unstable:
        // https://github.com/fingerprintjs/fingerprintjs/issues/583
        // https://github.com/fingerprintjs/fingerprintjs/issues/103
        // Therefore it's extracted into a separate image.
        text: makeTextImage(canvas, context)
    };
}
function makeCanvasContext() {
    const canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = 1;
    return [
        canvas,
        canvas.getContext("2d")
    ];
}
function isSupported(canvas, context) {
    // TODO: look into: https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob
    return !!(context && canvas.toDataURL);
}
function doesSupportWinding(context) {
    // https://web.archive.org/web/20170825024655/http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js
    context.rect(0, 0, 10, 10);
    context.rect(2, 2, 6, 6);
    return !context.isPointInPath(5, 5, "evenodd");
}
function makeTextImage(canvas, context) {
    // Resizing the canvas cleans it
    canvas.width = 240;
    canvas.height = 60;
    context.textBaseline = "alphabetic";
    context.fillStyle = "#f60";
    context.fillRect(100, 1, 62, 20);
    context.fillStyle = "#069";
    // It's important to use explicit built-in fonts in order to exclude the affect of font preferences
    // (there is a separate entropy source for them).
    context.font = '11pt "Times New Roman"';
    // The choice of emojis has a gigantic impact on rendering performance (especially in FF).
    // Some newer emojis cause it to slow down 50-200 times.
    // There must be no text to the right of the emoji, see https://github.com/fingerprintjs/fingerprintjs/issues/574
    // A bare emoji shouldn't be used because the canvas will change depending on the script encoding:
    // https://github.com/fingerprintjs/fingerprintjs/issues/66
    // Escape sequence shouldn't be used too because Terser will turn it into a bare unicode.
    const printedText = `Cwm fjordbank gly ${String.fromCharCode(55357, 56835)}`;
    context.fillText(printedText, 2, 15);
    context.fillStyle = "rgba(102, 204, 0, 0.2)";
    context.font = "18pt Arial";
    context.fillText(printedText, 4, 45);
    return save(canvas);
}
function makeGeometryImage(canvas, context) {
    // Resizing the canvas cleans it
    canvas.width = 122;
    canvas.height = 110;
    // Canvas blending
    // https://web.archive.org/web/20170826194121/http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
    // http://jsfiddle.net/NDYV8/16/
    context.globalCompositeOperation = "multiply";
    for (const [color, x, y] of [
        [
            "#f2f",
            40,
            40
        ],
        [
            "#2ff",
            80,
            40
        ],
        [
            "#ff2",
            60,
            80
        ]
    ]){
        context.fillStyle = color;
        context.beginPath();
        context.arc(x, y, 40, 0, Math.PI * 2, true);
        context.closePath();
        context.fill();
    }
    // Canvas winding
    // https://web.archive.org/web/20130913061632/http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
    // http://jsfiddle.net/NDYV8/19/
    context.fillStyle = "#f9c";
    context.arc(60, 60, 60, 0, Math.PI * 2, true);
    context.arc(60, 60, 20, 0, Math.PI * 2, true);
    context.fill("evenodd");
    return save(canvas);
}
function save(canvas) {
    // TODO: look into: https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob
    return canvas.toDataURL();
}

},{"./utils":"j3UO3","@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"j3UO3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toInt", ()=>toInt);
parcelHelpers.export(exports, "toFloat", ()=>toFloat);
parcelHelpers.export(exports, "rafOrTimeout", ()=>rafOrTimeout);
function toInt(value, replaceNaN) {
    const possibleNumber = parseInt(value);
    return isNaN(possibleNumber) ? replaceNaN : possibleNumber;
}
function toFloat(value, replaceNan) {
    const possibleFloat = parseFloat(value);
    return isNaN(possibleFloat) ? replaceNan : possibleFloat;
}
function fireOnce(cb) {
    let fired = false;
    return ()=>{
        if (fired) return;
        fired = true;
        cb();
    };
}
function defer(cb) {
    cb = fireOnce(cb);
    const visible = document.visibilityState !== "hidden";
    const fun = visible ? window.requestAnimationFrame || window.setTimeout : window.setTimeout;
    if (visible) {
        const fireCallbackWhenHidden = ()=>{
            if (document.visibilityState !== "hidden") return;
            cb();
        };
        document.addEventListener("visibilitychange", fireCallbackWhenHidden);
    }
    fun(cb);
}
function rafOrTimeout(fn) {
    return new Promise((resolve)=>{
        defer(()=>resolve(fn()));
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"4wE2H":[function(require,module,exports,__globalThis) {
// https://github.com/fingerprintjs/fingerprintjs/blob/v3.3.2/src/sources/math.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @see https://gitlab.torproject.org/legacy/trac/-/issues/13018
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=531915
 */ parcelHelpers.export(exports, "getMathFingerprint", ()=>getMathFingerprint);
const noop = ()=>0;
// Native operations
const acos = Math.acos || noop;
const acosh = Math.acosh || noop;
const asin = Math.asin || noop;
const asinh = Math.asinh || noop;
const atanh = Math.atanh || noop;
const atan = Math.atan || noop;
const sin = Math.sin || noop;
const sinh = Math.sinh || noop;
const cos = Math.cos || noop;
const cosh = Math.cosh || noop;
const tan = Math.tan || noop;
const tanh = Math.tanh || noop;
const exp = Math.exp || noop;
const expm1 = Math.expm1 || noop;
const log1p = Math.log1p || noop;
// Operation polyfills
const acoshPf = (value)=>Math.log(value + Math.sqrt(value * value - 1));
const asinhPf = (value)=>Math.log(value + Math.sqrt(value * value + 1));
const atanhPf = (value)=>Math.log((1 + value) / (1 - value)) / 2;
const sinhPf = (value)=>Math.exp(value) - 1 / Math.exp(value) / 2;
const coshPf = (value)=>(Math.exp(value) + 1 / Math.exp(value)) / 2;
const expm1Pf = (value)=>Math.exp(value) - 1;
const tanhPf = (value)=>(Math.exp(2 * value) - 1) / (Math.exp(2 * value) + 1);
const log1pPf = (value)=>Math.log(1 + value);
function getMathFingerprint() {
    // Note: constant values are empirical
    return {
        acos: acos(0.123124234234234242),
        acosh: acosh(1e308),
        acoshPf: acoshPf(1e154),
        asin: asin(0.123124234234234242),
        asinh: asinh(1),
        asinhPf: asinhPf(1),
        atanh: atanh(0.5),
        atanhPf: atanhPf(0.5),
        atan: atan(0.5),
        sin: sin(-1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000),
        sinh: sinh(1),
        sinhPf: sinhPf(1),
        cos: cos(10.000000000123),
        cosh: cosh(1),
        coshPf: coshPf(1),
        tan: tan(-1000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000),
        tanh: tanh(1),
        tanhPf: tanhPf(1),
        exp: exp(1),
        expm1: expm1(1),
        expm1Pf: expm1Pf(1),
        log1p: log1p(10),
        log1pPf: log1pPf(10),
        powPI: Math.pow(Math.PI, -100)
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"2evtl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTimezone", ()=>getTimezone);
function getTimezone() {
    if (Intl.DateTimeFormat) return Intl.DateTimeFormat().resolvedOptions().timeZone;
    // modern browsers might never need the code below
    const offset = new Date().getTimezoneOffset();
    return `${offset}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"imzAa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHardwareConcurrency", ()=>getHardwareConcurrency);
var _utils = require("./utils");
function getHardwareConcurrency() {
    return (0, _utils.toInt)(navigator.hardwareConcurrency, -1);
}

},{"./utils":"j3UO3","@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"aFGAa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDeviceMemory", ()=>getDeviceMemory);
var _utils = require("./utils");
function getDeviceMemory() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (0, _utils.toFloat)(navigator.deviceMemory, -1);
}

},{"./utils":"j3UO3","@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"3pjBf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWebGLInfo", ()=>getWebGLInfo);
function getWebGLInfo() {
    const canvas = document.createElement("canvas");
    const gl = canvas.getContext("webgl");
    const rendererInfo = gl?.getExtension("WEBGL_debug_renderer_info");
    if (!rendererInfo || !gl) return {
        vendor: "",
        renderer: ""
    };
    return {
        vendor: gl.getParameter(rendererInfo.UNMASKED_VENDOR_WEBGL),
        renderer: gl.getParameter(rendererInfo.UNMASKED_RENDERER_WEBGL)
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"bdzaw":[function(require,module,exports,__globalThis) {
// This is a mix of:
// - https://github.com/fingerprintjs/fingerprintjs/blob/master/src/sources/vendor.ts
// - https://github.com/fingerprintjs/fingerprintjs/blob/master/src/sources/vendor_flavors.ts
/**
 * Checks for browser-specific (not engine specific) global variables to tell browsers with the same engine apart.
 * Only somewhat popular browsers are considered.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVendorFlavors", ()=>getVendorFlavors);
function getVendorFlavors() {
    const vendor = navigator.vendor || "";
    const flavors = [
        vendor
    ];
    for (const key of [
        // Blink and some browsers on iOS
        "chrome",
        // Safari on macOS
        "safari",
        // Chrome on iOS (checked in 85 on 13 and 87 on 14)
        "__crWeb",
        "__gCrWeb",
        // Yandex Browser on iOS, macOS and Android (checked in 21.2 on iOS 14, macOS and Android)
        "yandex",
        // Yandex Browser on iOS (checked in 21.2 on 14)
        "__yb",
        "__ybro",
        // Firefox on iOS (checked in 32 on 14)
        "__firefox__",
        // Edge on iOS (checked in 46 on 14)
        "__edgeTrackingPreventionStatistics",
        "webkit",
        // Opera Touch on iOS (checked in 2.6 on 14)
        "oprt",
        // Samsung Internet on Android (checked in 11.1)
        "samsungAr",
        // UC Browser on Android (checked in 12.10 and 13.0)
        "ucweb",
        "UCShellJava",
        // Puffin on Android (checked in 9.0)
        "puffinDevice"
    ]){
        const value = window[key];
        if (value && typeof value === "object") flavors.push(key);
    }
    return flavors.sort().join(",");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"1nPmy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLanguages", ()=>getLanguages);
const langProperties = [
    "language",
    "browserLanguage",
    "systemLanguage",
    "userLanguage"
];
function getLanguages() {
    const languages = navigator.languages || [];
    const additionalLanguages = langProperties.map((prop)=>navigator[prop] || "").filter(Boolean);
    return languages.concat(additionalLanguages).join(",");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"gOBq4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMediaMatches", ()=>getMediaMatches);
parcelHelpers.export(exports, "isLandscape", ()=>isLandscape);
function doesMatch(type, value) {
    return matchMedia(`(${type}: ${value})`).matches;
}
const invertedColors = "inverted-colors";
// taken from https://github.com/fingerprintjs/fingerprintjs/blob/master/src/sources/inverted_colors.ts
function getColorsInverted() {
    if (doesMatch(invertedColors, "inverted")) return 2;
    if (doesMatch(invertedColors, "none")) return 1;
    return 0;
}
const forcedColors = "forced-colors";
// taken from https://github.com/fingerprintjs/fingerprintjs/blob/master/src/sources/forced_colors.ts
function getColorsForced() {
    if (doesMatch(forcedColors, "active")) return 2;
    if (doesMatch(forcedColors, "none")) return 1;
    return 0;
}
// rec2020 includes p3 and p3 includes srgb
const gamuts = [
    "srgb",
    "p3",
    "rec2020"
];
const colorGamut = "color-gamut";
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/color-gamut
 */ function getColorGamut() {
    for(let i = 0; i < gamuts.length; i++){
        const gamut = gamuts[i];
        if (matchMedia(`(${colorGamut}: ${gamut})`).matches) return i + 1;
    }
    return 0;
}
const dynamicRange = "dynamic-range";
function getHDR() {
    if (doesMatch(dynamicRange, "high")) return 2;
    if (doesMatch(dynamicRange, "standard")) return 1;
    return 0;
}
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
 */ const prefersReducedMotion = "prefers-reduced-motion";
function getMotionReduced() {
    if (doesMatch(prefersReducedMotion, "reduce")) return 2;
    if (doesMatch(prefersReducedMotion, "no-preference")) return 1;
    return 0;
}
function getMediaMatches() {
    return getMotionReduced() * 10000 + getHDR() * 1000 + getColorGamut() * 100 + getColorsInverted() * 10 + getColorsForced();
}
function isLandscape() {
    return doesMatch("orientation", "landscape");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"eyjOo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSupportedAudioTypes", ()=>getSupportedAudioTypes);
parcelHelpers.export(exports, "getSupportedVideoTypes", ()=>getSupportedVideoTypes);
const possibleAudioTypes = [
    "audio/3gpp",
    "audio/3gpp2",
    "audio/AMR-NB",
    "audio/AMR-WB",
    "audio/GSM",
    "audio/aac",
    "audio/basic",
    "audio/flac",
    "audio/midi",
    "audio/mpeg",
    'audio/mp4; codecs="mp4a.40.2"',
    'audio/mp4; codecs="ac-3"',
    'audio/mp4; codecs="ec-3"',
    'audio/ogg; codecs="flac"',
    'audio/ogg; codecs="vorbis"',
    'audio/ogg; codecs="opus"',
    'audio/wav; codecs="1"',
    'audio/webm; codecs="vorbis"',
    'audio/webm; codecs="opus"',
    "audio/x-aiff",
    "audio/x-mpegurl"
].sort();
const possibleVideoTypes = [
    'video/mp4; codecs="flac"',
    'video/mp4; codecs="H.264, mp3"',
    'video/mp4; codecs="H.264, aac"',
    'video/mpeg; codec="H.264"',
    'video/ogg; codecs="theora"',
    'video/ogg; codecs="opus"',
    'video/webm; codecs="vp9, opus"',
    'video/webm; codecs="vp8, vorbis"'
].sort();
const elements = {};
function canPlay(source, type) {
    const el = elements[source] || document.createElement(source);
    elements[source] = el;
    return el && el.canPlayType && el.canPlayType(type);
}
function toSupportDescription(source, type) {
    let supported;
    if (MediaSource.isTypeSupported) supported = MediaSource.isTypeSupported(type);
    const playable = canPlay(source, type);
    return {
        name: type,
        support: supported,
        playable
    };
}
function getSupportedAudioTypes() {
    return possibleAudioTypes.map((f)=>toSupportDescription("audio", f)).filter((f)=>!!f);
}
function getSupportedVideoTypes() {
    return possibleVideoTypes.map((f)=>toSupportDescription("video", f)).filter((f)=>!!f);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"4Xj9y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getScreenDiff", ()=>getScreenDiff);
parcelHelpers.export(exports, "getScreenDimentions", ()=>getScreenDimentions);
var _mediaMatches = require("./mediaMatches");
function getScreenDiff() {
    const { availHeight, availWidth, width, height } = window.screen;
    return {
        heightDiff: height - availHeight,
        widthDiff: width - availWidth
    };
}
function getScreenDimentions(win = window) {
    const pixelRatio = win.devicePixelRatio || 1;
    let { width, height } = win.screen;
    if (!(0, _mediaMatches.isLandscape)()) {
        const w = width;
        width = height;
        height = w;
    }
    return {
        width: width * pixelRatio,
        height: height * pixelRatio
    };
}

},{"./mediaMatches":"gOBq4","@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"32uyi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNativeNavigatorFunctions", ()=>getNativeNavigatorFunctions);
function isNative(obj) {
    return obj && typeof obj === "function" && obj.toString().indexOf("[native code]") > 0;
}
function getNativeNavigatorFunctions() {
    const props = [];
    for(const property in navigator){
        const value = navigator[property];
        if (isNative(value)) props.push(property);
    }
    return props.sort().join(",");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"740dl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPermissions", ()=>getPermissions);
const possiblePermissions = [
    "accelerometer",
    "accessibility",
    "ambient-light-sensor",
    "camera",
    "clipboard-read",
    "clipboard-write",
    "geolocation",
    "background-sync",
    "magnetometer",
    "microphone",
    "midi",
    "notifications",
    "payment-handler",
    "persistent-storage",
    "push"
];
function getPermission(name) {
    if (!navigator.permissions) return Promise.resolve({
        name,
        present: false
    });
    return navigator.permissions.query({
        name: name
    }).then((_)=>({
            name,
            present: true
        }), (_)=>({
            name,
            present: false
        }));
}
function getPermissions() {
    const permissions = possiblePermissions.map((name)=>getPermission(name));
    return Promise.all(permissions);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"iyBLw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVendor", ()=>getVendor);
function getVendor() {
    const n = navigator;
    return `${n.buildID},${n.product},${n.productSub},${n.vendor},${n.vendorSub}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"lu85g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUserAgent", ()=>getUserAgent);
function getUserAgent() {
    return navigator.userAgent || "none";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"kzviu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hash", ()=>hash);
parcelHelpers.export(exports, "createVerifier", ()=>createVerifier);
var _murmurhash3Js = require("murmurhash3js");
function hash(payload) {
    if (typeof payload !== "string") payload = JSON.stringify(payload);
    return _murmurhash3Js.x64.hash128(payload);
}
function createVerifier({ browserHash, visitorId, baseName, type }) {
    const input = [
        browserHash,
        visitorId,
        type && type !== "load" ? type : undefined
    ].filter((s)=>s !== undefined).join(",");
    return _murmurhash3Js.x86.hash32(input, baseName || 0);
}

},{"murmurhash3js":"lJSR4","@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"lJSR4":[function(require,module,exports,__globalThis) {
module.exports = require("d7a75bcd38c0f7ee");

},{"d7a75bcd38c0f7ee":"1cvNN"}],"1cvNN":[function(require,module,exports,__globalThis) {
/* jshint -W086: true */ // +----------------------------------------------------------------------+
// | murmurHash3js.js v3.0.1 // https://github.com/pid/murmurHash3js
// | A javascript implementation of MurmurHash3's x86 hashing algorithms. |
// |----------------------------------------------------------------------|
// | Copyright (c) 2012-2015 Karan Lyons                                       |
// | https://github.com/karanlyons/murmurHash3.js/blob/c1778f75792abef7bdd74bc85d2d4e1a3d25cfe9/murmurHash3.js |
// | Freely distributable under the MIT license.                          |
// +----------------------------------------------------------------------+
(function(root, undefined) {
    'use strict';
    // Create a local object that'll be exported or referenced globally.
    var library = {
        'version': '3.0.1',
        'x86': {},
        'x64': {}
    };
    // PRIVATE FUNCTIONS
    // -----------------
    function _x86Multiply(m, n) {
        //
        // Given two 32bit ints, returns the two multiplied together as a
        // 32bit int.
        //
        return (m & 0xffff) * n + (((m >>> 16) * n & 0xffff) << 16);
    }
    function _x86Rotl(m, n) {
        //
        // Given a 32bit int and an int representing a number of bit positions,
        // returns the 32bit int rotated left by that number of positions.
        //
        return m << n | m >>> 32 - n;
    }
    function _x86Fmix(h) {
        //
        // Given a block, returns murmurHash3's final x86 mix of that block.
        //
        h ^= h >>> 16;
        h = _x86Multiply(h, 0x85ebca6b);
        h ^= h >>> 13;
        h = _x86Multiply(h, 0xc2b2ae35);
        h ^= h >>> 16;
        return h;
    }
    function _x64Add(m, n) {
        //
        // Given two 64bit ints (as an array of two 32bit ints) returns the two
        // added together as a 64bit int (as an array of two 32bit ints).
        //
        m = [
            m[0] >>> 16,
            m[0] & 0xffff,
            m[1] >>> 16,
            m[1] & 0xffff
        ];
        n = [
            n[0] >>> 16,
            n[0] & 0xffff,
            n[1] >>> 16,
            n[1] & 0xffff
        ];
        var o = [
            0,
            0,
            0,
            0
        ];
        o[3] += m[3] + n[3];
        o[2] += o[3] >>> 16;
        o[3] &= 0xffff;
        o[2] += m[2] + n[2];
        o[1] += o[2] >>> 16;
        o[2] &= 0xffff;
        o[1] += m[1] + n[1];
        o[0] += o[1] >>> 16;
        o[1] &= 0xffff;
        o[0] += m[0] + n[0];
        o[0] &= 0xffff;
        return [
            o[0] << 16 | o[1],
            o[2] << 16 | o[3]
        ];
    }
    function _x64Multiply(m, n) {
        //
        // Given two 64bit ints (as an array of two 32bit ints) returns the two
        // multiplied together as a 64bit int (as an array of two 32bit ints).
        //
        m = [
            m[0] >>> 16,
            m[0] & 0xffff,
            m[1] >>> 16,
            m[1] & 0xffff
        ];
        n = [
            n[0] >>> 16,
            n[0] & 0xffff,
            n[1] >>> 16,
            n[1] & 0xffff
        ];
        var o = [
            0,
            0,
            0,
            0
        ];
        o[3] += m[3] * n[3];
        o[2] += o[3] >>> 16;
        o[3] &= 0xffff;
        o[2] += m[2] * n[3];
        o[1] += o[2] >>> 16;
        o[2] &= 0xffff;
        o[2] += m[3] * n[2];
        o[1] += o[2] >>> 16;
        o[2] &= 0xffff;
        o[1] += m[1] * n[3];
        o[0] += o[1] >>> 16;
        o[1] &= 0xffff;
        o[1] += m[2] * n[2];
        o[0] += o[1] >>> 16;
        o[1] &= 0xffff;
        o[1] += m[3] * n[1];
        o[0] += o[1] >>> 16;
        o[1] &= 0xffff;
        o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
        o[0] &= 0xffff;
        return [
            o[0] << 16 | o[1],
            o[2] << 16 | o[3]
        ];
    }
    function _x64Rotl(m, n) {
        //
        // Given a 64bit int (as an array of two 32bit ints) and an int
        // representing a number of bit positions, returns the 64bit int (as an
        // array of two 32bit ints) rotated left by that number of positions.
        //
        n %= 64;
        if (n === 32) return [
            m[1],
            m[0]
        ];
        else if (n < 32) return [
            m[0] << n | m[1] >>> 32 - n,
            m[1] << n | m[0] >>> 32 - n
        ];
        else {
            n -= 32;
            return [
                m[1] << n | m[0] >>> 32 - n,
                m[0] << n | m[1] >>> 32 - n
            ];
        }
    }
    function _x64LeftShift(m, n) {
        //
        // Given a 64bit int (as an array of two 32bit ints) and an int
        // representing a number of bit positions, returns the 64bit int (as an
        // array of two 32bit ints) shifted left by that number of positions.
        //
        n %= 64;
        if (n === 0) return m;
        else if (n < 32) return [
            m[0] << n | m[1] >>> 32 - n,
            m[1] << n
        ];
        else return [
            m[1] << n - 32,
            0
        ];
    }
    function _x64Xor(m, n) {
        //
        // Given two 64bit ints (as an array of two 32bit ints) returns the two
        // xored together as a 64bit int (as an array of two 32bit ints).
        //
        return [
            m[0] ^ n[0],
            m[1] ^ n[1]
        ];
    }
    function _x64Fmix(h) {
        //
        // Given a block, returns murmurHash3's final x64 mix of that block.
        // (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
        // only place where we need to right shift 64bit ints.)
        //
        h = _x64Xor(h, [
            0,
            h[0] >>> 1
        ]);
        h = _x64Multiply(h, [
            0xff51afd7,
            0xed558ccd
        ]);
        h = _x64Xor(h, [
            0,
            h[0] >>> 1
        ]);
        h = _x64Multiply(h, [
            0xc4ceb9fe,
            0x1a85ec53
        ]);
        h = _x64Xor(h, [
            0,
            h[0] >>> 1
        ]);
        return h;
    }
    // PUBLIC FUNCTIONS
    // ----------------
    library.x86.hash32 = function(key, seed) {
        //
        // Given a string and an optional seed as an int, returns a 32 bit hash
        // using the x86 flavor of MurmurHash3, as an unsigned int.
        //
        key = key || '';
        seed = seed || 0;
        var remainder = key.length % 4;
        var bytes = key.length - remainder;
        var h1 = seed;
        var k1 = 0;
        var c1 = 0xcc9e2d51;
        var c2 = 0x1b873593;
        for(var i = 0; i < bytes; i = i + 4){
            k1 = key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24;
            k1 = _x86Multiply(k1, c1);
            k1 = _x86Rotl(k1, 15);
            k1 = _x86Multiply(k1, c2);
            h1 ^= k1;
            h1 = _x86Rotl(h1, 13);
            h1 = _x86Multiply(h1, 5) + 0xe6546b64;
        }
        k1 = 0;
        switch(remainder){
            case 3:
                k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
            case 2:
                k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
            case 1:
                k1 ^= key.charCodeAt(i) & 0xff;
                k1 = _x86Multiply(k1, c1);
                k1 = _x86Rotl(k1, 15);
                k1 = _x86Multiply(k1, c2);
                h1 ^= k1;
        }
        h1 ^= key.length;
        h1 = _x86Fmix(h1);
        return h1 >>> 0;
    };
    library.x86.hash128 = function(key, seed) {
        //
        // Given a string and an optional seed as an int, returns a 128 bit
        // hash using the x86 flavor of MurmurHash3, as an unsigned hex.
        //
        key = key || '';
        seed = seed || 0;
        var remainder = key.length % 16;
        var bytes = key.length - remainder;
        var h1 = seed;
        var h2 = seed;
        var h3 = seed;
        var h4 = seed;
        var k1 = 0;
        var k2 = 0;
        var k3 = 0;
        var k4 = 0;
        var c1 = 0x239b961b;
        var c2 = 0xab0e9789;
        var c3 = 0x38b34ae5;
        var c4 = 0xa1e38b93;
        for(var i = 0; i < bytes; i = i + 16){
            k1 = key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24;
            k2 = key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24;
            k3 = key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24;
            k4 = key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24;
            k1 = _x86Multiply(k1, c1);
            k1 = _x86Rotl(k1, 15);
            k1 = _x86Multiply(k1, c2);
            h1 ^= k1;
            h1 = _x86Rotl(h1, 19);
            h1 += h2;
            h1 = _x86Multiply(h1, 5) + 0x561ccd1b;
            k2 = _x86Multiply(k2, c2);
            k2 = _x86Rotl(k2, 16);
            k2 = _x86Multiply(k2, c3);
            h2 ^= k2;
            h2 = _x86Rotl(h2, 17);
            h2 += h3;
            h2 = _x86Multiply(h2, 5) + 0x0bcaa747;
            k3 = _x86Multiply(k3, c3);
            k3 = _x86Rotl(k3, 17);
            k3 = _x86Multiply(k3, c4);
            h3 ^= k3;
            h3 = _x86Rotl(h3, 15);
            h3 += h4;
            h3 = _x86Multiply(h3, 5) + 0x96cd1c35;
            k4 = _x86Multiply(k4, c4);
            k4 = _x86Rotl(k4, 18);
            k4 = _x86Multiply(k4, c1);
            h4 ^= k4;
            h4 = _x86Rotl(h4, 13);
            h4 += h1;
            h4 = _x86Multiply(h4, 5) + 0x32ac3b17;
        }
        k1 = 0;
        k2 = 0;
        k3 = 0;
        k4 = 0;
        switch(remainder){
            case 15:
                k4 ^= key.charCodeAt(i + 14) << 16;
            case 14:
                k4 ^= key.charCodeAt(i + 13) << 8;
            case 13:
                k4 ^= key.charCodeAt(i + 12);
                k4 = _x86Multiply(k4, c4);
                k4 = _x86Rotl(k4, 18);
                k4 = _x86Multiply(k4, c1);
                h4 ^= k4;
            case 12:
                k3 ^= key.charCodeAt(i + 11) << 24;
            case 11:
                k3 ^= key.charCodeAt(i + 10) << 16;
            case 10:
                k3 ^= key.charCodeAt(i + 9) << 8;
            case 9:
                k3 ^= key.charCodeAt(i + 8);
                k3 = _x86Multiply(k3, c3);
                k3 = _x86Rotl(k3, 17);
                k3 = _x86Multiply(k3, c4);
                h3 ^= k3;
            case 8:
                k2 ^= key.charCodeAt(i + 7) << 24;
            case 7:
                k2 ^= key.charCodeAt(i + 6) << 16;
            case 6:
                k2 ^= key.charCodeAt(i + 5) << 8;
            case 5:
                k2 ^= key.charCodeAt(i + 4);
                k2 = _x86Multiply(k2, c2);
                k2 = _x86Rotl(k2, 16);
                k2 = _x86Multiply(k2, c3);
                h2 ^= k2;
            case 4:
                k1 ^= key.charCodeAt(i + 3) << 24;
            case 3:
                k1 ^= key.charCodeAt(i + 2) << 16;
            case 2:
                k1 ^= key.charCodeAt(i + 1) << 8;
            case 1:
                k1 ^= key.charCodeAt(i);
                k1 = _x86Multiply(k1, c1);
                k1 = _x86Rotl(k1, 15);
                k1 = _x86Multiply(k1, c2);
                h1 ^= k1;
        }
        h1 ^= key.length;
        h2 ^= key.length;
        h3 ^= key.length;
        h4 ^= key.length;
        h1 += h2;
        h1 += h3;
        h1 += h4;
        h2 += h1;
        h3 += h1;
        h4 += h1;
        h1 = _x86Fmix(h1);
        h2 = _x86Fmix(h2);
        h3 = _x86Fmix(h3);
        h4 = _x86Fmix(h4);
        h1 += h2;
        h1 += h3;
        h1 += h4;
        h2 += h1;
        h3 += h1;
        h4 += h1;
        return ("00000000" + (h1 >>> 0).toString(16)).slice(-8) + ("00000000" + (h2 >>> 0).toString(16)).slice(-8) + ("00000000" + (h3 >>> 0).toString(16)).slice(-8) + ("00000000" + (h4 >>> 0).toString(16)).slice(-8);
    };
    library.x64.hash128 = function(key, seed) {
        //
        // Given a string and an optional seed as an int, returns a 128 bit
        // hash using the x64 flavor of MurmurHash3, as an unsigned hex.
        //
        key = key || '';
        seed = seed || 0;
        var remainder = key.length % 16;
        var bytes = key.length - remainder;
        var h1 = [
            0,
            seed
        ];
        var h2 = [
            0,
            seed
        ];
        var k1 = [
            0,
            0
        ];
        var k2 = [
            0,
            0
        ];
        var c1 = [
            0x87c37b91,
            0x114253d5
        ];
        var c2 = [
            0x4cf5ad43,
            0x2745937f
        ];
        for(var i = 0; i < bytes; i = i + 16){
            k1 = [
                key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24,
                key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24
            ];
            k2 = [
                key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24,
                key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24
            ];
            k1 = _x64Multiply(k1, c1);
            k1 = _x64Rotl(k1, 31);
            k1 = _x64Multiply(k1, c2);
            h1 = _x64Xor(h1, k1);
            h1 = _x64Rotl(h1, 27);
            h1 = _x64Add(h1, h2);
            h1 = _x64Add(_x64Multiply(h1, [
                0,
                5
            ]), [
                0,
                0x52dce729
            ]);
            k2 = _x64Multiply(k2, c2);
            k2 = _x64Rotl(k2, 33);
            k2 = _x64Multiply(k2, c1);
            h2 = _x64Xor(h2, k2);
            h2 = _x64Rotl(h2, 31);
            h2 = _x64Add(h2, h1);
            h2 = _x64Add(_x64Multiply(h2, [
                0,
                5
            ]), [
                0,
                0x38495ab5
            ]);
        }
        k1 = [
            0,
            0
        ];
        k2 = [
            0,
            0
        ];
        switch(remainder){
            case 15:
                k2 = _x64Xor(k2, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 14)
                ], 48));
            case 14:
                k2 = _x64Xor(k2, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 13)
                ], 40));
            case 13:
                k2 = _x64Xor(k2, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 12)
                ], 32));
            case 12:
                k2 = _x64Xor(k2, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 11)
                ], 24));
            case 11:
                k2 = _x64Xor(k2, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 10)
                ], 16));
            case 10:
                k2 = _x64Xor(k2, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 9)
                ], 8));
            case 9:
                k2 = _x64Xor(k2, [
                    0,
                    key.charCodeAt(i + 8)
                ]);
                k2 = _x64Multiply(k2, c2);
                k2 = _x64Rotl(k2, 33);
                k2 = _x64Multiply(k2, c1);
                h2 = _x64Xor(h2, k2);
            case 8:
                k1 = _x64Xor(k1, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 7)
                ], 56));
            case 7:
                k1 = _x64Xor(k1, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 6)
                ], 48));
            case 6:
                k1 = _x64Xor(k1, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 5)
                ], 40));
            case 5:
                k1 = _x64Xor(k1, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 4)
                ], 32));
            case 4:
                k1 = _x64Xor(k1, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 3)
                ], 24));
            case 3:
                k1 = _x64Xor(k1, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 2)
                ], 16));
            case 2:
                k1 = _x64Xor(k1, _x64LeftShift([
                    0,
                    key.charCodeAt(i + 1)
                ], 8));
            case 1:
                k1 = _x64Xor(k1, [
                    0,
                    key.charCodeAt(i)
                ]);
                k1 = _x64Multiply(k1, c1);
                k1 = _x64Rotl(k1, 31);
                k1 = _x64Multiply(k1, c2);
                h1 = _x64Xor(h1, k1);
        }
        h1 = _x64Xor(h1, [
            0,
            key.length
        ]);
        h2 = _x64Xor(h2, [
            0,
            key.length
        ]);
        h1 = _x64Add(h1, h2);
        h2 = _x64Add(h2, h1);
        h1 = _x64Fmix(h1);
        h2 = _x64Fmix(h2);
        h1 = _x64Add(h1, h2);
        h2 = _x64Add(h2, h1);
        return ("00000000" + (h1[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h1[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[1] >>> 0).toString(16)).slice(-8);
    };
    if (module.exports) exports = module.exports = library;
    exports.murmurHash3 = library;
})(this);

},{}],"1uMWY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPromiseLike", ()=>isPromiseLike);
function isPromiseLike(possiblePromise) {
    return possiblePromise && typeof possiblePromise.then === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"hnpU2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ping1", ()=>ping1);
var _hash = require("./hash");
var _path = require("./path");
var _remoteLogging = require("./remote-logging");
function addImage(...segments) {
    const png = document.createElement("img");
    png.src = (0, _path.computePath)(...segments);
    png.style.cssText = "position: absolute; top: -100px";
    document.body.appendChild(png);
}
function cacheBuster() {
    return Math.floor(Math.random() * 100000000);
}
function ping1({ browserHash, visitorId, elapsed, type }) {
    type = type || "load";
    try {
        const baseName = cacheBuster();
        browserHash = browserHash || "-";
        visitorId = visitorId || "-";
        elapsed = elapsed || 0;
        const verifier = (0, _hash.createVerifier)({
            browserHash,
            visitorId,
            baseName,
            type
        });
        addImage("/pxl", type !== "load" ? type : "", `${browserHash}/${visitorId}/${elapsed}/${baseName}-${verifier}.png`);
    } catch (error) {
        (0, _remoteLogging.logError)(error);
    }
}

},{"./hash":"kzviu","./path":"89JNt","./remote-logging":"98WE3","@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"89JNt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "computePath", ()=>computePath);
function computeBasePath() {
    const script = document.getElementById("pingme");
    if (!script || !script.src) //bail out
    return "";
    const split = script.src.split("/");
    return `${split[0]}//${split[2]}`;
}
function computePath(...segments) {
    if (segments && segments.length > 1) {
        const path = segments.filter(Boolean).map((segments)=>segments.replace(/^\/|\/$/g, "")).join("/");
        return computePath(path);
    }
    const basePath = computeBasePath();
    let path = segments[0];
    if (!path) return basePath;
    if (path.indexOf("/") === 0) path = path.substring(1);
    return `${basePath}/${path}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"98WE3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isError", ()=>isError);
parcelHelpers.export(exports, "logError", ()=>logError);
parcelHelpers.export(exports, "log", ()=>log);
var _etag = require("./etag");
var _fetch = require("./fetch");
var _path = require("./path");
function isError(e) {
    return e && e.message && e.name;
}
function logError(error) {
    let message;
    if (isError(error)) {
        message = `${error.name}: ${error.message}`;
        const stack = error.stack;
        if (stack) message += `\n${stack}`;
    } else message = error.message || JSON.stringify(error);
    return log("ERROR", message);
}
function log(level, message) {
    return (0, _fetch.postJson)((0, _path.computePath)("/log/hash"), {
        level,
        message,
        etag: (0, _etag.getEtag)()
    });
}

},{"./etag":"axaLj","./fetch":"dHmXv","./path":"89JNt","@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"axaLj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEtag", ()=>getEtag);
const etag = "###[randomUUID]###".split(".");
function getEtag() {
    return (etag[1] || etag[0]).replace("randomUUID", `${Math.floor(Math.random() * 10000000000)}`).replace("###[", "").replace("]###", "");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"dHmXv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "postJson", ()=>postJson);
function postJson(path, payload) {
    return fetch(path, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"7bO3N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVisitorId", ()=>getVisitorId);
var _browserCookies = require("browser-cookies");
var _uuid = require("uuid");
var _etag = require("./etag");
var _hash = require("./hash");
const key = "__va";
function createVisitorId() {
    const id = (0, _uuid.v4)();
    const tag = (0, _etag.getEtag)();
    return (0, _hash.hash)(`${tag}.${id}`);
}
function getVisitorId() {
    const cookieVa = _browserCookies.get(key);
    const localStorageVa = localStorage.getItem(key);
    let vaValue = cookieVa || localStorageVa;
    if (vaValue && vaValue.length !== 32) vaValue = "";
    const id = vaValue || createVisitorId();
    // ensure/update the va value
    _browserCookies.set(key, id, {
        expires: 365
    });
    if (vaValue !== localStorageVa) localStorage.setItem(key, id);
    return id;
}

},{"browser-cookies":"12YIL","uuid":[["v4","aj7So","default"]],"./etag":"axaLj","./hash":"kzviu","@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"12YIL":[function(require,module,exports,__globalThis) {
exports.defaults = {};
exports.set = function(name, value, options) {
    // Retrieve options and defaults
    var opts = options || {};
    var defaults = exports.defaults;
    // Apply default value for unspecified options
    var expires = opts.expires || defaults.expires;
    var domain = opts.domain || defaults.domain;
    var path = opts.path !== undefined ? opts.path : defaults.path !== undefined ? defaults.path : '/';
    var secure = opts.secure !== undefined ? opts.secure : defaults.secure;
    var httponly = opts.httponly !== undefined ? opts.httponly : defaults.httponly;
    var samesite = opts.samesite !== undefined ? opts.samesite : defaults.samesite;
    // Determine cookie expiration date
    // If succesful the result will be a valid Date, otherwise it will be an invalid Date or false(ish)
    var expDate = expires ? new Date(// in case expires is an integer, it should specify the number of days till the cookie expires
    typeof expires === 'number' ? new Date().getTime() + expires * 864e5 : // else expires should be either a Date object or in a format recognized by Date.parse()
    expires) : 0;
    // Set cookie
    document.cookie = name.replace(/[^+#$&^`|]/g, encodeURIComponent) // Encode cookie name
    .replace('(', '%28').replace(')', '%29') + '=' + value.replace(/[^+#$&/:<-\[\]-}]/g, encodeURIComponent) + // Encode cookie value (RFC6265)
    (expDate && expDate.getTime() >= 0 ? ';expires=' + expDate.toUTCString() : '') + // Add expiration date
    (domain ? ';domain=' + domain : '') + // Add domain
    (path ? ';path=' + path : '') + // Add path
    (secure ? ';secure' : '') + // Add secure option
    (httponly ? ';httponly' : '') + // Add httponly option
    (samesite ? ';samesite=' + samesite : ''); // Add samesite option
};
exports.get = function(name) {
    var cookies = document.cookie.split(';');
    // Iterate all cookies
    while(cookies.length){
        var cookie = cookies.pop();
        // Determine separator index ("name=value")
        var separatorIndex = cookie.indexOf('=');
        // IE<11 emits the equal sign when the cookie value is empty
        separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;
        var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));
        // Return cookie value if the name matches
        if (cookie_name === name) return decodeURIComponent(cookie.slice(separatorIndex + 1));
    }
    // Return `null` as the cookie was not found
    return null;
};
exports.erase = function(name, options) {
    exports.set(name, '', {
        expires: -1,
        domain: options && options.domain,
        path: options && options.path,
        secure: 0,
        httponly: 0
    });
};
exports.all = function() {
    var all = {};
    var cookies = document.cookie.split(';');
    // Iterate all cookies
    while(cookies.length){
        var cookie = cookies.pop();
        // Determine separator index ("name=value")
        var separatorIndex = cookie.indexOf('=');
        // IE<11 emits the equal sign when the cookie value is empty
        separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;
        // add the cookie name and value to the `all` object
        var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));
        all[cookie_name] = decodeURIComponent(cookie.slice(separatorIndex + 1));
    }
    return all;
};

},{}],"aj7So":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJsDefault.default)(rnds);
}
exports.default = v4;

},{"./rng.js":"5qwbJ","./stringify.js":"amZkY","@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"5qwbJ":[function(require,module,exports,__globalThis) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"amZkY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"5emKz","@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"5emKz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === 'string' && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"eRgJ7","@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"eRgJ7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"3jsEl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LandingPage", ()=>LandingPage);
var _jsxRuntime = require("react/jsx-runtime");
var _twind = require("twind");
var _devicesSvg = require("data-url:./devices.svg");
var _devicesSvgDefault = parcelHelpers.interopDefault(_devicesSvg);
var _bgSvg = require("data-url:./bg.svg");
var _bgSvgDefault = parcelHelpers.interopDefault(_bgSvg);
var _preact = require("preact");
var _version = require("../version");
function Navigation() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _twind.tw)`w-full container mx-auto p-6`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _twind.tw)`w-full flex items-center justify-between`,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                    className: (0, _twind.tw)`flex items-center text-indigo-400 no-underline hover:no-underline font-bold text-2xl lg:text-4xl`,
                    href: "#",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                            className: (0, _twind.tw)`h-8 fill-current text-indigo-600 pr-2`,
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm-5.6-4.29a9.95 9.95 0 0 1 11.2 0 8 8 0 1 0-11.2 0zm6.12-7.64l3.02-3.02 1.41 1.41-3.02 3.02a2 2 0 1 1-1.41-1.41z"
                            })
                        }),
                        "Ping"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: (0, _twind.tw)`flex w-1/2 justify-end content-center`
                })
            ]
        })
    });
}
function Footer() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _twind.tw)`w-full pt-16 pb-6 text-sm text-center md:text-left`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
            className: (0, _twind.tw)`text-gray-500 no-underline hover:no-underline`,
            href: "#",
            children: [
                "Ping Service v",
                (0, _version.getVersion)()
            ]
        })
    });
}
function LandingPageHero() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _preact.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _twind.tw)`flex flex-col w-full xl:w-2/5 justify-center lg:items-start overflow-y-hidden`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: (0, _twind.tw)`my-4 text-3xl md:text-5xl text-purple-800 font-bold leading-tight text-center md:text-left`,
                        children: "Ping Service for the world"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: (0, _twind.tw)`leading-normal text-base md:text-2xl mb-8 text-center md:text-left`,
                        children: "Allow users to notify of their existence by making use of this service"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _twind.tw)`w-full xl:w-3/5 py-6 overflow-y-hidden`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    alt: "Devices",
                    className: (0, _twind.tw)`w-5/6 mx-auto lg:mr-0`,
                    src: (0, _devicesSvgDefault.default)
                })
            })
        ]
    });
}
const screenStyle = {
    backgroundImage: `url(${(0, _bgSvgDefault.default)})`
};
function LandingPage(_) {
    return(// https://github.com/tailwindtoolbox/App-Landing-Page/blob/master/index.html
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("main", {
        className: (0, _twind.tw)`leading-normal tracking-normal text-gray-900`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _twind.tw)`h-screen pb-14 bg-right bg-cover`,
            style: screenStyle,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Navigation, {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: (0, _twind.tw)`container pt-24 md:pt-48 px-6 mx-auto flex flex-wrap flex-col md:flex-row items-center`,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(LandingPageHero, {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Footer, {})
                    ]
                })
            ]
        })
    }));
}

},{"react/jsx-runtime":"2JAJE","twind":"9hS8o","data-url:./devices.svg":"bAFmu","data-url:./bg.svg":"3THnn","preact":"7Pucd","../version":"7bE3F","@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"2JAJE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Fragment", ()=>(0, _preact.Fragment));
parcelHelpers.export(exports, "jsx", ()=>u);
parcelHelpers.export(exports, "jsxAttr", ()=>l);
parcelHelpers.export(exports, "jsxDEV", ()=>u);
parcelHelpers.export(exports, "jsxEscape", ()=>s);
parcelHelpers.export(exports, "jsxTemplate", ()=>a);
parcelHelpers.export(exports, "jsxs", ()=>u);
var _preact = require("preact");
var t = /["&<]/;
function n(r) {
    if (0 === r.length || !1 === t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, f = 0, i = Array.isArray;
function u(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: --f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, _preact.options).vnode && (0, _preact.options).vnode(l), l;
}
function a(r) {
    var t = u((0, _preact.Fragment), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var c = {}, p = /[A-Z]/g;
function l(e, t) {
    if ((0, _preact.options).attr) {
        var f = (0, _preact.options).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if (t = function(r) {
        return null !== r && "object" == typeof r && "function" == typeof r.valueOf ? r.valueOf() : r;
    }(t), "ref" === e || "key" === e) return "";
    if ("style" === e && "object" == typeof t) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : c[u] || (c[u] = u.replace(p, "-$&").toLowerCase()), s = ";";
                "number" != typeof a || l.startsWith("--") || o.test(l) || (s = "px;"), i = i + l + ":" + a + s;
            }
        }
        return e + '="' + n(i) + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == typeof t ? "" : !0 === t ? e : e + '="' + n("" + t) + '"';
}
function s(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == typeof r) {
        if (void 0 === r.constructor) return r;
        if (i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = s(r[e]);
            return r;
        }
    }
    return n("" + r);
}

},{"preact":"7Pucd","@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"9hS8o":[function(require,module,exports,__globalThis) {
// src/internal/util.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apply", ()=>apply);
parcelHelpers.export(exports, "autoprefix", ()=>autoprefix);
parcelHelpers.export(exports, "create", ()=>create);
parcelHelpers.export(exports, "cssomSheet", ()=>cssomSheet);
parcelHelpers.export(exports, "directive", ()=>directive);
parcelHelpers.export(exports, "expandGroups", ()=>expandGroups);
parcelHelpers.export(exports, "hash", ()=>cyrb32);
parcelHelpers.export(exports, "mode", ()=>mode);
parcelHelpers.export(exports, "noprefix", ()=>noprefix);
parcelHelpers.export(exports, "setup", ()=>setup);
parcelHelpers.export(exports, "silent", ()=>silent);
parcelHelpers.export(exports, "strict", ()=>strict);
parcelHelpers.export(exports, "theme", ()=>theme);
parcelHelpers.export(exports, "tw", ()=>tw);
parcelHelpers.export(exports, "voidSheet", ()=>voidSheet);
parcelHelpers.export(exports, "warn", ()=>warn);
// src/twind/prefix.ts
var _styleVendorizer = require("style-vendorizer");
var includes = (value, search)=>!!~value.indexOf(search);
var join = (parts, separator = "-")=>parts.join(separator);
var joinTruthy = (parts, separator)=>join(parts.filter(Boolean), separator);
var tail = (array, startIndex = 1)=>array.slice(startIndex);
var identity = (value)=>value;
var noop = ()=>{};
var capitalize = (value)=>value[0].toUpperCase() + tail(value);
var hyphenate = (value)=>value.replace(/[A-Z]/g, "-$&").toLowerCase();
var evalThunk = (value, context)=>{
    while(typeof value == "function")value = value(context);
    return value;
};
var ensureMaxSize = (map, max)=>{
    if (map.size > max) map.delete(map.keys().next().value);
};
var isCSSProperty = (key, value)=>!includes("@:&", key[0]) && (includes("rg", (typeof value)[5]) || Array.isArray(value));
var merge = (target, source, context)=>source ? Object.keys(source).reduce((target2, key)=>{
        const value = evalThunk(source[key], context);
        if (isCSSProperty(key, value)) target2[hyphenate(key)] = value;
        else target2[key] = key[0] == "@" && includes("figa", key[1]) ? (target2[key] || []).concat(value) : merge(target2[key] || {}, value, context);
        return target2;
    }, target) : target;
var escape = typeof CSS !== "undefined" && CSS.escape || ((className)=>className.replace(/[!"'`*+.,;:\\/<=>?@#$%&^|~()[\]{}]/g, "\\$&").replace(/^\d/, "\\3$& "));
var buildMediaQuery = (screen)=>{
    if (!Array.isArray(screen)) screen = [
        screen
    ];
    return "@media " + join(screen.map((screen2)=>{
        if (typeof screen2 == "string") screen2 = {
            min: screen2
        };
        return screen2.raw || join(Object.keys(screen2).map((feature)=>`(${feature}-width:${screen2[feature]})`), " and ");
    }), ",");
};
var cyrb32 = (value)=>{
    for(var h = 9, index = value.length; index--;)h = Math.imul(h ^ value.charCodeAt(index), 1597334677);
    return "tw-" + ((h ^ h >>> 9) >>> 0).toString(36);
};
var sortedInsertionIndex = (array, element)=>{
    for(var low = 0, high = array.length; low < high;){
        const pivot = high + low >> 1;
        if (array[pivot] <= element) low = pivot + 1;
        else high = pivot;
    }
    return high;
};
// src/twind/parse.ts
var groupings;
var rules;
var startGrouping = (value = "")=>{
    groupings.push(value);
    return "";
};
var endGrouping = (isWhitespace)=>{
    groupings.length = Math.max(groupings.lastIndexOf("") + ~~isWhitespace, 0);
};
var onlyPrefixes = (s)=>s && !includes("!:", s[0]);
var onlyVariants = (s)=>s[0] == ":";
var addRule = (directive2, negate)=>{
    rules.push({
        v: groupings.filter(onlyVariants),
        d: directive2,
        n: negate,
        i: includes(groupings, "!"),
        $: ""
    });
};
var saveRule = (buffer)=>{
    const negate = buffer[0] == "-";
    if (negate) buffer = tail(buffer);
    const prefix = join(groupings.filter(onlyPrefixes));
    addRule(buffer == "&" ? prefix : (prefix && prefix + "-") + buffer, negate);
    return "";
};
var parseString = (token, isVariant)=>{
    let buffer = "";
    for(let char, dynamic = false, position2 = 0; char = token[position2++];){
        if (dynamic || char == "[") {
            buffer += char;
            dynamic = char != "]";
            continue;
        }
        switch(char){
            case ":":
                buffer = buffer && startGrouping(":" + (token[position2] == char ? token[position2++] : "") + buffer);
                break;
            case "(":
                buffer = buffer && startGrouping(buffer);
                startGrouping();
                break;
            case "!":
                startGrouping(char);
                break;
            case ")":
            case " ":
            case "	":
            case "\n":
            case "\r":
                buffer = buffer && saveRule(buffer);
                endGrouping(char !== ")");
                break;
            default:
                buffer += char;
        }
    }
    if (buffer) {
        if (isVariant) startGrouping(":" + buffer);
        else if (buffer.slice(-1) == "-") startGrouping(buffer.slice(0, -1));
        else saveRule(buffer);
    }
};
var parseGroupedToken = (token)=>{
    startGrouping();
    parseToken(token);
    endGrouping();
};
var parseGroup = (key, token)=>{
    if (token) {
        startGrouping();
        const isVariant = includes("tbu", (typeof token)[1]);
        parseString(key, isVariant);
        if (isVariant) parseGroupedToken(token);
        endGrouping();
    }
};
var parseToken = (token)=>{
    switch(typeof token){
        case "string":
            parseString(token);
            break;
        case "function":
            addRule(token);
            break;
        case "object":
            if (Array.isArray(token)) token.forEach(parseGroupedToken);
            else if (token) Object.keys(token).forEach((key)=>{
                parseGroup(key, token[key]);
            });
    }
};
var staticsCaches = new WeakMap();
var buildStatics = (strings)=>{
    let statics = staticsCaches.get(strings);
    if (!statics) {
        let slowModeIndex = NaN;
        let buffer = "";
        statics = strings.map((token, index)=>{
            if (slowModeIndex !== slowModeIndex && (token.slice(-1) == "[" || includes(":-(", (strings[index + 1] || "")[0]))) slowModeIndex = index;
            if (index >= slowModeIndex) return (interpolation)=>{
                if (index == slowModeIndex) buffer = "";
                buffer += token;
                if (includes("rg", (typeof interpolation)[5])) buffer += interpolation;
                else if (interpolation) {
                    parseString(buffer);
                    buffer = "";
                    parseToken(interpolation);
                }
                if (index == strings.length - 1) parseString(buffer);
            };
            const staticRules = rules = [];
            parseString(token);
            const activeGroupings = [
                ...groupings
            ];
            rules = [];
            return (interpolation)=>{
                rules.push(...staticRules);
                groupings = [
                    ...activeGroupings
                ];
                if (interpolation) parseToken(interpolation);
            };
        });
        staticsCaches.set(strings, statics);
    }
    return statics;
};
var parse = (tokens)=>{
    groupings = [];
    rules = [];
    if (Array.isArray(tokens[0]) && Array.isArray(tokens[0].raw)) buildStatics(tokens[0]).forEach((apply2, index)=>apply2(tokens[index + 1]));
    else parseToken(tokens);
    return rules;
};
// src/twind/directive.ts
var isFunctionFree;
var detectFunction = (key, value)=>{
    if (typeof value == "function") isFunctionFree = false;
    return value;
};
var stringify = (data)=>{
    isFunctionFree = true;
    const key = JSON.stringify(data, detectFunction);
    return isFunctionFree && key;
};
var cacheByFactory = new WeakMap();
var directive = (factory, data)=>{
    const key = stringify(data);
    let directive2;
    if (key) {
        var cache = cacheByFactory.get(factory);
        if (!cache) cacheByFactory.set(factory, cache = new Map());
        directive2 = cache.get(key);
    }
    if (!directive2) {
        directive2 = Object.defineProperty((params, context)=>{
            context = Array.isArray(params) ? context : params;
            return evalThunk(factory(data, context), context);
        }, "toJSON", {
            value: ()=>key || data
        });
        if (cache) {
            cache.set(key, directive2);
            ensureMaxSize(cache, 1e4);
        }
    }
    return directive2;
};
// src/twind/apply.ts
var applyFactory = (tokens, { css })=>css(parse(tokens));
var apply = (...tokens)=>directive(applyFactory, tokens);
// src/twind/helpers.ts
var positions = (resolve)=>(value, position2, prefix, suffix)=>{
        if (value) {
            const properties = position2 && resolve(position2);
            if (properties && properties.length > 0) return properties.reduce((declarations, property2)=>{
                declarations[joinTruthy([
                    prefix,
                    property2,
                    suffix
                ])] = value;
                return declarations;
            }, {});
        }
    };
var corners = /* @__PURE__ */ positions((key)=>({
        t: [
            "top-left",
            "top-right"
        ],
        r: [
            "top-right",
            "bottom-right"
        ],
        b: [
            "bottom-left",
            "bottom-right"
        ],
        l: [
            "bottom-left",
            "top-left"
        ],
        tl: [
            "top-left"
        ],
        tr: [
            "top-right"
        ],
        bl: [
            "bottom-left"
        ],
        br: [
            "bottom-right"
        ]
    })[key]);
var expandEdges = (key)=>{
    const parts = (({
        x: "lr",
        y: "tb"
    })[key] || key || "").split("").sort();
    for(let index = parts.length; index--;){
        if (!(parts[index] = ({
            t: "top",
            r: "right",
            b: "bottom",
            l: "left"
        })[parts[index]])) return;
    }
    if (parts.length) return parts;
};
var edges = /* @__PURE__ */ positions(expandEdges);
var stringifyVariant = (selector, variant)=>selector + (variant[1] == ":" ? tail(variant, 2) + ":" : tail(variant)) + ":";
var stringifyRule = (rule, directive2 = rule.d)=>typeof directive2 == "function" ? "" : rule.v.reduce(stringifyVariant, "") + (rule.i ? "!" : "") + (rule.n ? "-" : "") + directive2;
// src/twind/plugins.ts
var _;
var __;
var $;
var toColumnsOrRows = (x)=>x == "cols" ? "columns" : "rows";
var property = (property2)=>(params, context, id)=>({
            [property2]: id + ((_ = join(params)) && "-" + _)
        });
var propertyValue = (property2, separator)=>(params, context, id)=>(_ = join(params, separator)) && {
            [property2 || id]: _
        };
var themeProperty = (section)=>(params, { theme: theme2 }, id)=>(_ = theme2(section || id, params)) && {
            [section || id]: _
        };
var themePropertyFallback = (section, separator)=>(params, { theme: theme2 }, id)=>(_ = theme2(section || id, params, join(params, separator))) && {
            [section || id]: _
        };
var alias = (handler, name)=>(params, context)=>handler(params, context, name);
var display = property("display");
var position = property("position");
var textTransform = property("textTransform");
var textDecoration = property("textDecoration");
var fontStyle = property("fontStyle");
var fontVariantNumeric = (key)=>(params, context, id)=>({
            ["--tw-" + key]: id,
            fontVariantNumeric: "var(--tw-ordinal,/*!*/ /*!*/) var(--tw-slashed-zero,/*!*/ /*!*/) var(--tw-numeric-figure,/*!*/ /*!*/) var(--tw-numeric-spacing,/*!*/ /*!*/) var(--tw-numeric-fraction,/*!*/ /*!*/)"
        });
var inset = (params, { theme: theme2 }, id)=>(_ = theme2("inset", params)) && {
        [id]: _
    };
var opacityProperty = (params, theme2, id, section = id)=>(_ = theme2(section + "Opacity", tail(params))) && {
        [`--tw-${id}-opacity`]: _
    };
var parseColorComponent = (chars, factor)=>Math.round(parseInt(chars, 16) * factor);
var asRGBA = (color, opacityProperty2, opacityDefault)=>{
    if (color && color[0] == "#" && (_ = (color.length - 1) / 3) && ($ = [
        17,
        1,
        0.062272
    ][_ - 1])) return `rgba(${parseColorComponent(color.substr(1, _), $)},${parseColorComponent(color.substr(1 + _, _), $)},${parseColorComponent(color.substr(1 + 2 * _, _), $)},${opacityProperty2 ? `var(--tw-${opacityProperty2}${opacityDefault ? "," + opacityDefault : ""})` : opacityDefault || 1})`;
    return color;
};
var withOpacityFallback = (property2, kind, color)=>color && typeof color == "string" ? (_ = asRGBA(color, kind + "-opacity")) && _ !== color ? {
        [`--tw-${kind}-opacity`]: "1",
        [property2]: [
            color,
            _
        ]
    } : {
        [property2]: color
    } : void 0;
var transparentTo = (color)=>($ = asRGBA(color, "", "0")) == _ ? "transparent" : $;
var reversableEdge = (params, { theme: theme2 }, id, section, prefix, suffix)=>(_ = ({
        x: [
            "right",
            "left"
        ],
        y: [
            "bottom",
            "top"
        ]
    })[params[0]]) && ($ = `--tw-${id}-${params[0]}-reverse`) ? params[1] == "reverse" ? {
        [$]: "1"
    } : {
        [$]: "0",
        [joinTruthy([
            prefix,
            _[0],
            suffix
        ])]: (__ = theme2(section, tail(params))) && `calc(${__} * var(${$}))`,
        [joinTruthy([
            prefix,
            _[1],
            suffix
        ])]: __ && [
            __,
            `calc(${__} * calc(1 - var(${$})))`
        ]
    } : void 0;
var placeHelper = (property2, params)=>params[0] && {
        [property2]: (includes("wun", (params[0] || "")[3]) ? "space-" : "") + params[0]
    };
var contentPluginFor = (property2)=>(params)=>includes([
            "start",
            "end"
        ], params[0]) ? {
            [property2]: "flex-" + params[0]
        } : placeHelper(property2, params);
var gridPlugin = (kind)=>(params, { theme: theme2 })=>{
        if (_ = theme2("grid" + capitalize(kind), params, "")) return {
            ["grid-" + kind]: _
        };
        switch(params[0]){
            case "span":
                return params[1] && {
                    ["grid-" + kind]: `span ${params[1]} / span ${params[1]}`
                };
            case "start":
            case "end":
                return (_ = theme2("grid" + capitalize(kind) + capitalize(params[0]), tail(params), join(tail(params)))) && {
                    [`grid-${kind}-${params[0]}`]: _
                };
        }
    };
var border = (params, { theme: theme2 }, id)=>{
    switch(params[0]){
        case "solid":
        case "dashed":
        case "dotted":
        case "double":
        case "none":
            return propertyValue("borderStyle")(params);
        case "collapse":
        case "separate":
            return propertyValue("borderCollapse")(params);
        case "opacity":
            return opacityProperty(params, theme2, id);
    }
    return (_ = theme2(id + "Width", params, "")) ? {
        borderWidth: _
    } : withOpacityFallback("borderColor", id, theme2(id + "Color", params));
};
var borderEdges = (params, context, id)=>{
    var _a;
    const edges2 = (_a = expandEdges(params[0])) == null ? void 0 : _a.map(capitalize);
    if (edges2) params = tail(params);
    let rules2 = border(params, context, id);
    if (edges2 && rules2 && typeof rules2 === "object") rules2 = Object.entries(rules2).reduce((newRules, [key, value])=>{
        if (key.startsWith("border")) for (const edge of edges2)newRules[key.slice(0, 6) + edge + key.slice(6)] = value;
        else newRules[key] = value;
        return newRules;
    }, {});
    return rules2;
};
var transform = (gpu)=>(gpu ? "translate3d(var(--tw-translate-x,0),var(--tw-translate-y,0),0)" : "translateX(var(--tw-translate-x,0)) translateY(var(--tw-translate-y,0))") + " rotate(var(--tw-rotate,0)) skewX(var(--tw-skew-x,0)) skewY(var(--tw-skew-y,0)) scaleX(var(--tw-scale-x,1)) scaleY(var(--tw-scale-y,1))";
var transformXYFunction = (params, context, id)=>params[0] && (_ = context.theme(id, params[1] || params[0])) && {
        [`--tw-${id}-x`]: params[0] !== "y" && _,
        [`--tw-${id}-y`]: params[0] !== "x" && _,
        transform: [
            `${id}${params[1] ? params[0].toUpperCase() : ""}(${_})`,
            transform()
        ]
    };
var edgesPluginFor = (key)=>(params, context, id)=>id[1] ? edges(context.theme(key, params), id[1], key) : themeProperty(key)(params, context, id);
var padding = edgesPluginFor("padding");
var margin = edgesPluginFor("margin");
var minMax = (params, { theme: theme2 }, id)=>(_ = ({
        w: "width",
        h: "height"
    })[params[0]]) && {
        [_ = `${id}${capitalize(_)}`]: theme2(_, tail(params))
    };
var filter = (params, { theme: theme2 }, id)=>{
    const parts = id.split("-");
    const prefix = parts[0] == "backdrop" ? parts[0] + "-" : "";
    if (!prefix) params.unshift(...parts);
    if (params[0] == "filter") {
        const filters = [
            "blur",
            "brightness",
            "contrast",
            "grayscale",
            "hue-rotate",
            "invert",
            prefix && "opacity",
            "saturate",
            "sepia",
            !prefix && "drop-shadow"
        ].filter(Boolean);
        return params[1] == "none" ? {
            [prefix + "filter"]: "none"
        } : filters.reduce((css, key)=>{
            css["--tw-" + prefix + key] = "var(--tw-empty,/*!*/ /*!*/)";
            return css;
        }, {
            [prefix + "filter"]: filters.map((key)=>`var(--tw-${prefix}${key})`).join(" ")
        });
    }
    $ = params.shift();
    if (includes([
        "hue",
        "drop"
    ], $)) $ += capitalize(params.shift());
    return (_ = theme2(prefix ? "backdrop" + capitalize($) : $, params)) && {
        ["--tw-" + prefix + $]: (Array.isArray(_) ? _ : [
            _
        ]).map((_4)=>`${hyphenate($)}(${_4})`).join(" ")
    };
};
var corePlugins = {
    group: (params, { tag }, id)=>tag(join([
            id,
            ...params
        ])),
    hidden: alias(display, "none"),
    inline: display,
    block: display,
    contents: display,
    flow: display,
    table: (params, context, id)=>includes([
            "auto",
            "fixed"
        ], params[0]) ? {
            tableLayout: params[0]
        } : display(params, context, id),
    flex (params, context, id) {
        switch(params[0]){
            case "row":
            case "col":
                return {
                    flexDirection: join(params[0] == "col" ? [
                        "column",
                        ...tail(params)
                    ] : params)
                };
            case "nowrap":
            case "wrap":
                return {
                    flexWrap: join(params)
                };
            case "grow":
            case "shrink":
                _ = context.theme("flex" + capitalize(params[0]), tail(params), params[1] || 1);
                return _ != null && {
                    ["flex-" + params[0]]: "" + _
                };
        }
        return (_ = context.theme("flex", params, "")) ? {
            flex: _
        } : display(params, context, id);
    },
    grid (params, context, id) {
        switch(params[0]){
            case "cols":
            case "rows":
                return (_ = context.theme("gridTemplate" + capitalize(toColumnsOrRows(params[0])), tail(params), params.length == 2 && Number(params[1]) ? `repeat(${params[1]},minmax(0,1fr))` : join(tail(params)))) && {
                    ["gridTemplate-" + toColumnsOrRows(params[0])]: _
                };
            case "flow":
                return params.length > 1 && {
                    gridAutoFlow: join(params[1] == "col" ? [
                        "column",
                        ...tail(params, 2)
                    ] : tail(params), " ")
                };
        }
        return display(params, context, id);
    },
    auto: (params, { theme: theme2 })=>includes([
            "cols",
            "rows"
        ], params[0]) && (_ = theme2("gridAuto" + capitalize(toColumnsOrRows(params[0])), tail(params), join(tail(params)))) && {
            ["gridAuto-" + toColumnsOrRows(params[0])]: _
        },
    static: position,
    fixed: position,
    absolute: position,
    relative: position,
    sticky: position,
    visible: {
        visibility: "visible"
    },
    invisible: {
        visibility: "hidden"
    },
    antialiased: {
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale"
    },
    "subpixel-antialiased": {
        WebkitFontSmoothing: "auto",
        MozOsxFontSmoothing: "auto"
    },
    truncate: {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis"
    },
    "sr-only": {
        position: "absolute",
        width: "1px",
        height: "1px",
        padding: "0",
        margin: "-1px",
        overflow: "hidden",
        whiteSpace: "nowrap",
        clip: "rect(0,0,0,0)",
        borderWidth: "0"
    },
    "not-sr-only": {
        position: "static",
        width: "auto",
        height: "auto",
        padding: "0",
        margin: "0",
        overflow: "visible",
        whiteSpace: "normal",
        clip: "auto"
    },
    resize: (params)=>({
            resize: ({
                x: "horizontal",
                y: "vertical"
            })[params[0]] || params[0] || "both"
        }),
    box: (params)=>params[0] && {
            boxSizing: params[0] + "-box"
        },
    appearance: propertyValue(),
    cursor: themePropertyFallback(),
    float: propertyValue(),
    clear: propertyValue(),
    decoration: propertyValue("boxDecorationBreak"),
    isolate: {
        isolation: "isolate"
    },
    isolation: propertyValue(),
    "mix-blend": propertyValue("mixBlendMode"),
    top: inset,
    right: inset,
    bottom: inset,
    left: inset,
    inset: (params, { theme: theme2 })=>(_ = expandEdges(params[0])) ? edges(theme2("inset", tail(params)), params[0]) : (_ = theme2("inset", params)) && {
            top: _,
            right: _,
            bottom: _,
            left: _
        },
    underline: textDecoration,
    "line-through": textDecoration,
    "no-underline": alias(textDecoration, "none"),
    "text-underline": alias(textDecoration, "underline"),
    "text-no-underline": alias(textDecoration, "none"),
    "text-line-through": alias(textDecoration, "line-through"),
    uppercase: textTransform,
    lowercase: textTransform,
    capitalize: textTransform,
    "normal-case": alias(textTransform, "none"),
    "text-normal-case": alias(textTransform, "none"),
    italic: fontStyle,
    "not-italic": alias(fontStyle, "normal"),
    "font-italic": alias(fontStyle, "italic"),
    "font-not-italic": alias(fontStyle, "normal"),
    font: (params, context, id)=>(_ = context.theme("fontFamily", params, "")) ? {
            fontFamily: _
        } : themeProperty("fontWeight")(params, context, id),
    items: (params)=>params[0] && {
            alignItems: includes([
                "start",
                "end"
            ], params[0]) ? "flex-" + params[0] : join(params)
        },
    "justify-self": propertyValue(),
    "justify-items": propertyValue(),
    justify: contentPluginFor("justifyContent"),
    content: contentPluginFor("alignContent"),
    self: contentPluginFor("alignSelf"),
    place: (params)=>params[0] && placeHelper("place-" + params[0], tail(params)),
    overscroll: (params)=>params[0] && {
            ["overscrollBehavior" + (params[1] ? "-" + params[0] : "")]: params[1] || params[0]
        },
    col: gridPlugin("column"),
    row: gridPlugin("row"),
    duration: themeProperty("transitionDuration"),
    delay: themeProperty("transitionDelay"),
    tracking: themeProperty("letterSpacing"),
    leading: themeProperty("lineHeight"),
    z: themeProperty("zIndex"),
    opacity: themeProperty(),
    ease: themeProperty("transitionTimingFunction"),
    p: padding,
    py: padding,
    px: padding,
    pt: padding,
    pr: padding,
    pb: padding,
    pl: padding,
    m: margin,
    my: margin,
    mx: margin,
    mt: margin,
    mr: margin,
    mb: margin,
    ml: margin,
    w: themeProperty("width"),
    h: themeProperty("height"),
    min: minMax,
    max: minMax,
    fill: themeProperty(),
    order: themeProperty(),
    origin: themePropertyFallback("transformOrigin", " "),
    select: propertyValue("userSelect"),
    "pointer-events": propertyValue(),
    align: propertyValue("verticalAlign"),
    whitespace: propertyValue("whiteSpace"),
    "normal-nums": {
        fontVariantNumeric: "normal"
    },
    ordinal: fontVariantNumeric("ordinal"),
    "slashed-zero": fontVariantNumeric("slashed-zero"),
    "lining-nums": fontVariantNumeric("numeric-figure"),
    "oldstyle-nums": fontVariantNumeric("numeric-figure"),
    "proportional-nums": fontVariantNumeric("numeric-spacing"),
    "tabular-nums": fontVariantNumeric("numeric-spacing"),
    "diagonal-fractions": fontVariantNumeric("numeric-fraction"),
    "stacked-fractions": fontVariantNumeric("numeric-fraction"),
    overflow: (params, context, id)=>includes([
            "ellipsis",
            "clip"
        ], params[0]) ? propertyValue("textOverflow")(params) : params[1] ? {
            ["overflow-" + params[0]]: params[1]
        } : propertyValue()(params, context, id),
    transform: (params)=>params[0] == "none" ? {
            transform: "none"
        } : {
            "--tw-translate-x": "0",
            "--tw-translate-y": "0",
            "--tw-rotate": "0",
            "--tw-skew-x": "0",
            "--tw-skew-y": "0",
            "--tw-scale-x": "1",
            "--tw-scale-y": "1",
            transform: transform(params[0] == "gpu")
        },
    rotate: (params, { theme: theme2 })=>(_ = theme2("rotate", params)) && {
            "--tw-rotate": _,
            transform: [
                `rotate(${_})`,
                transform()
            ]
        },
    scale: transformXYFunction,
    translate: transformXYFunction,
    skew: transformXYFunction,
    gap: (params, context, id)=>(_ = ({
            x: "column",
            y: "row"
        })[params[0]]) ? {
            [_ + "Gap"]: context.theme("gap", tail(params))
        } : themeProperty("gap")(params, context, id),
    stroke: (params, context, id)=>(_ = context.theme("stroke", params, "")) ? {
            stroke: _
        } : themeProperty("strokeWidth")(params, context, id),
    outline: (params, { theme: theme2 })=>(_ = theme2("outline", params)) && {
            outline: _[0],
            outlineOffset: _[1]
        },
    "break-normal": {
        wordBreak: "normal",
        overflowWrap: "normal"
    },
    "break-words": {
        overflowWrap: "break-word"
    },
    "break-all": {
        wordBreak: "break-all"
    },
    text (params, { theme: theme2 }, id) {
        switch(params[0]){
            case "left":
            case "center":
            case "right":
            case "justify":
                return {
                    textAlign: params[0]
                };
            case "uppercase":
            case "lowercase":
            case "capitalize":
                return textTransform([], _, params[0]);
            case "opacity":
                return opacityProperty(params, theme2, id);
        }
        const fontSize = theme2("fontSize", params, "");
        if (fontSize) return typeof fontSize == "string" ? {
            fontSize
        } : {
            fontSize: fontSize[0],
            ...typeof fontSize[1] == "string" ? {
                lineHeight: fontSize[1]
            } : fontSize[1]
        };
        return withOpacityFallback("color", "text", theme2("textColor", params));
    },
    bg (params, { theme: theme2 }, id) {
        switch(params[0]){
            case "fixed":
            case "local":
            case "scroll":
                return propertyValue("backgroundAttachment", ",")(params);
            case "bottom":
            case "center":
            case "left":
            case "right":
            case "top":
                return propertyValue("backgroundPosition", " ")(params);
            case "no":
                return params[1] == "repeat" && propertyValue("backgroundRepeat")(params);
            case "repeat":
                return includes("xy", params[1]) ? propertyValue("backgroundRepeat")(params) : {
                    backgroundRepeat: params[1] || params[0]
                };
            case "opacity":
                return opacityProperty(params, theme2, id, "background");
            case "clip":
            case "origin":
                return params[1] && {
                    ["background-" + params[0]]: params[1] + (params[1] == "text" ? "" : "-box")
                };
            case "blend":
                return propertyValue("background-blend-mode")(tail(params));
            case "gradient":
                if (params[1] == "to" && (_ = expandEdges(params[2]))) return {
                    backgroundImage: `linear-gradient(to ${join(_, " ")},var(--tw-gradient-stops))`
                };
        }
        return (_ = theme2("backgroundPosition", params, "")) ? {
            backgroundPosition: _
        } : (_ = theme2("backgroundSize", params, "")) ? {
            backgroundSize: _
        } : (_ = theme2("backgroundImage", params, "")) ? {
            backgroundImage: _
        } : withOpacityFallback("backgroundColor", "bg", theme2("backgroundColor", params));
    },
    from: (params, { theme: theme2 })=>(_ = theme2("gradientColorStops", params)) && {
            "--tw-gradient-from": _,
            "--tw-gradient-stops": `var(--tw-gradient-from),var(--tw-gradient-to,${transparentTo(_)})`
        },
    via: (params, { theme: theme2 })=>(_ = theme2("gradientColorStops", params)) && {
            "--tw-gradient-stops": `var(--tw-gradient-from),${_},var(--tw-gradient-to,${transparentTo(_)})`
        },
    to: (params, { theme: theme2 })=>(_ = theme2("gradientColorStops", params)) && {
            "--tw-gradient-to": _
        },
    border: borderEdges,
    divide: (params, context, id)=>(_ = reversableEdge(params, context, id, "divideWidth", "border", "width") || border(params, context, id)) && {
            "&>:not([hidden])~:not([hidden])": _
        },
    space: (params, context, id)=>(_ = reversableEdge(params, context, id, "space", "margin")) && {
            "&>:not([hidden])~:not([hidden])": _
        },
    placeholder: (params, { theme: theme2 }, id)=>(_ = params[0] == "opacity" ? opacityProperty(params, theme2, id) : withOpacityFallback("color", "placeholder", theme2("placeholderColor", params))) && {
            "&::placeholder": _
        },
    shadow: (params, { theme: theme2 })=>(_ = theme2("boxShadow", params)) && {
            ":global": {
                "*": {
                    "--tw-shadow": "0 0 transparent"
                }
            },
            "--tw-shadow": _ == "none" ? "0 0 transparent" : _,
            boxShadow: [
                _,
                `var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow)`
            ]
        },
    animate: (params, { theme: theme2, tag })=>{
        if ($ = theme2("animation", params)) {
            const parts = $.split(" ");
            if ((_ = theme2("keyframes", parts[0], __ = {})) !== __) return ($ = tag(parts[0])) && {
                animation: $ + " " + join(tail(parts), " "),
                ["@keyframes " + $]: _
            };
            return {
                animation: $
            };
        }
    },
    ring (params, { theme: theme2 }, id) {
        switch(params[0]){
            case "inset":
                return {
                    "--tw-ring-inset": "inset"
                };
            case "opacity":
                return opacityProperty(params, theme2, id);
            case "offset":
                return (_ = theme2("ringOffsetWidth", tail(params), "")) ? {
                    "--tw-ring-offset-width": _
                } : {
                    "--tw-ring-offset-color": theme2("ringOffsetColor", tail(params))
                };
        }
        return (_ = theme2("ringWidth", params, "")) ? {
            "--tw-ring-offset-shadow": `var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)`,
            "--tw-ring-shadow": `var(--tw-ring-inset) 0 0 0 calc(${_} + var(--tw-ring-offset-width)) var(--tw-ring-color)`,
            boxShadow: `var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 transparent)`,
            ":global": {
                "*": {
                    "--tw-ring-inset": "var(--tw-empty,/*!*/ /*!*/)",
                    "--tw-ring-offset-width": theme2("ringOffsetWidth", "", "0px"),
                    "--tw-ring-offset-color": theme2("ringOffsetColor", "", "#fff"),
                    "--tw-ring-color": asRGBA(theme2("ringColor", "", "#93c5fd"), "ring-opacity", theme2("ringOpacity", "", "0.5")),
                    "--tw-ring-offset-shadow": "0 0 transparent",
                    "--tw-ring-shadow": "0 0 transparent"
                }
            }
        } : {
            "--tw-ring-opacity": "1",
            "--tw-ring-color": asRGBA(theme2("ringColor", params), "ring-opacity")
        };
    },
    object: (params, context, id)=>includes([
            "contain",
            "cover",
            "fill",
            "none",
            "scale-down"
        ], join(params)) ? {
            objectFit: join(params)
        } : themePropertyFallback("objectPosition", " ")(params, context, id),
    list: (params, context, id)=>join(params) == "item" ? display(params, context, id) : includes([
            "inside",
            "outside"
        ], join(params)) ? {
            listStylePosition: params[0]
        } : themePropertyFallback("listStyleType")(params, context, id),
    rounded: (params, context, id)=>corners(context.theme("borderRadius", tail(params), ""), params[0], "border", "radius") || themeProperty("borderRadius")(params, context, id),
    "transition-none": {
        transitionProperty: "none"
    },
    transition: (params, { theme: theme2 })=>({
            transitionProperty: theme2("transitionProperty", params),
            transitionTimingFunction: theme2("transitionTimingFunction", ""),
            transitionDuration: theme2("transitionDuration", "")
        }),
    container: (params, { theme: theme2 })=>{
        const { screens = theme2("screens"), center, padding: padding2 } = theme2("container");
        const paddingFor = (screen)=>(_ = padding2 && (typeof padding2 == "string" ? padding2 : padding2[screen] || padding2.DEFAULT)) ? {
                paddingRight: _,
                paddingLeft: _
            } : {};
        return Object.keys(screens).reduce((rules2, screen)=>{
            if (($ = screens[screen]) && typeof $ == "string") rules2[buildMediaQuery($)] = {
                "&": {
                    "max-width": $,
                    ...paddingFor(screen)
                }
            };
            return rules2;
        }, {
            width: "100%",
            ...center ? {
                marginRight: "auto",
                marginLeft: "auto"
            } : {},
            ...paddingFor("xs")
        });
    },
    filter,
    blur: filter,
    brightness: filter,
    contrast: filter,
    grayscale: filter,
    "hue-rotate": filter,
    invert: filter,
    saturate: filter,
    sepia: filter,
    "drop-shadow": filter,
    backdrop: filter
};
// src/twind/preflight.ts
var createPreflight = (theme2)=>({
        ":root": {
            tabSize: 4
        },
        "body,blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre,fieldset,ol,ul": {
            margin: "0"
        },
        button: {
            backgroundColor: "transparent",
            backgroundImage: "none"
        },
        'button,[type="button"],[type="reset"],[type="submit"]': {
            WebkitAppearance: "button"
        },
        "button:focus": {
            outline: [
                "1px dotted",
                "5px auto -webkit-focus-ring-color"
            ]
        },
        "fieldset,ol,ul,legend": {
            padding: "0"
        },
        "ol,ul": {
            listStyle: "none"
        },
        html: {
            lineHeight: "1.5",
            WebkitTextSizeAdjust: "100%",
            fontFamily: theme2("fontFamily.sans", "ui-sans-serif,system-ui,sans-serif")
        },
        body: {
            fontFamily: "inherit",
            lineHeight: "inherit"
        },
        "*,::before,::after": {
            boxSizing: "border-box",
            border: `0 solid ${theme2("borderColor.DEFAULT", "currentColor")}`
        },
        hr: {
            height: "0",
            color: "inherit",
            borderTopWidth: "1px"
        },
        img: {
            borderStyle: "solid"
        },
        textarea: {
            resize: "vertical"
        },
        "input::placeholder,textarea::placeholder": {
            opacity: "1",
            color: theme2("placeholderColor.DEFAULT", theme2("colors.gray.400", "#a1a1aa"))
        },
        'button,[role="button"]': {
            cursor: "pointer"
        },
        table: {
            textIndent: "0",
            borderColor: "inherit",
            borderCollapse: "collapse"
        },
        "h1,h2,h3,h4,h5,h6": {
            fontSize: "inherit",
            fontWeight: "inherit"
        },
        a: {
            color: "inherit",
            textDecoration: "inherit"
        },
        "button,input,optgroup,select,textarea": {
            fontFamily: "inherit",
            fontSize: "100%",
            margin: "0",
            padding: "0",
            lineHeight: "inherit",
            color: "inherit"
        },
        "button,select": {
            textTransform: "none"
        },
        "::-moz-focus-inner": {
            borderStyle: "none",
            padding: "0"
        },
        ":-moz-focusring": {
            outline: "1px dotted ButtonText"
        },
        ":-moz-ui-invalid": {
            boxShadow: "none"
        },
        progress: {
            verticalAlign: "baseline"
        },
        "::-webkit-inner-spin-button,::-webkit-outer-spin-button": {
            height: "auto"
        },
        '[type="search"]': {
            WebkitAppearance: "textfield",
            outlineOffset: "-2px"
        },
        "::-webkit-search-decoration": {
            WebkitAppearance: "none"
        },
        "::-webkit-file-upload-button": {
            WebkitAppearance: "button",
            font: "inherit"
        },
        summary: {
            display: "list-item"
        },
        "abbr[title]": {
            textDecoration: "underline dotted"
        },
        "b,strong": {
            fontWeight: "bolder"
        },
        "pre,code,kbd,samp": {
            fontFamily: theme2("fontFamily", "mono", "ui-monospace,monospace"),
            fontSize: "1em"
        },
        "sub,sup": {
            fontSize: "75%",
            lineHeight: "0",
            position: "relative",
            verticalAlign: "baseline"
        },
        sub: {
            bottom: "-0.25em"
        },
        sup: {
            top: "-0.5em"
        },
        "img,svg,video,canvas,audio,iframe,embed,object": {
            display: "block",
            verticalAlign: "middle"
        },
        "img,video": {
            maxWidth: "100%",
            height: "auto"
        }
    });
// src/twind/variants.ts
var coreVariants = {
    dark: "@media (prefers-color-scheme:dark)",
    sticky: "@supports ((position: -webkit-sticky) or (position:sticky))",
    "motion-reduce": "@media (prefers-reduced-motion:reduce)",
    "motion-safe": "@media (prefers-reduced-motion:no-preference)",
    first: "&:first-child",
    last: "&:last-child",
    even: "&:nth-child(2n)",
    odd: "&:nth-child(odd)",
    children: "&>*",
    siblings: "&~*",
    sibling: "&+*",
    override: "&&"
};
// src/internal/dom.ts
var STYLE_ELEMENT_ID = "__twind";
var getStyleElement = (nonce)=>{
    let element = self[STYLE_ELEMENT_ID];
    if (!element) {
        element = document.head.appendChild(document.createElement("style"));
        element.id = STYLE_ELEMENT_ID;
        nonce && (element.nonce = nonce);
        element.appendChild(document.createTextNode(""));
    }
    return element;
};
// src/twind/sheets.ts
var cssomSheet = ({ nonce, target = getStyleElement(nonce).sheet } = {})=>{
    const offset = target.cssRules.length;
    return {
        target,
        insert: (rule, index)=>target.insertRule(rule, offset + index)
    };
};
var voidSheet = ()=>({
        target: null,
        insert: noop
    });
// src/twind/modes.ts
var mode = (report)=>({
        unknown (section, key = [], optional, context) {
            if (!optional) this.report({
                id: "UNKNOWN_THEME_VALUE",
                key: section + "." + join(key)
            }, context);
        },
        report ({ id, ...info }) {
            return report(`[${id}] ${JSON.stringify(info)}`);
        }
    });
var warn = /* @__PURE__ */ mode((message)=>console.warn(message));
var strict = /* @__PURE__ */ mode((message)=>{
    throw new Error(message);
});
var silent = /* @__PURE__ */ mode(noop);
var noprefix = (property2, value, important)=>`${property2}:${value}${important ? " !important" : ""}`;
var autoprefix = (property2, value, important)=>{
    let cssText = "";
    const propertyAlias = (0, _styleVendorizer.cssPropertyAlias)(property2);
    if (propertyAlias) cssText += `${noprefix(propertyAlias, value, important)};`;
    let flags = (0, _styleVendorizer.cssPropertyPrefixFlags)(property2);
    if (flags & 1) cssText += `-webkit-${noprefix(property2, value, important)};`;
    if (flags & 2) cssText += `-moz-${noprefix(property2, value, important)};`;
    if (flags & 4) cssText += `-ms-${noprefix(property2, value, important)};`;
    flags = (0, _styleVendorizer.cssValuePrefixFlags)(property2, value);
    if (flags & 1) cssText += `${noprefix(property2, `-webkit-${value}`, important)};`;
    if (flags & 2) cssText += `${noprefix(property2, `-moz-${value}`, important)};`;
    if (flags & 4) cssText += `${noprefix(property2, `-ms-${value}`, important)};`;
    cssText += noprefix(property2, value, important);
    return cssText;
};
// src/twind/theme.ts
var ratios = (start, end)=>{
    const result = {};
    do for(let dividend = 1; dividend < start; dividend++)result[`${dividend}/${start}`] = Number((dividend / start * 100).toFixed(6)) + "%";
    while (++start <= end);
    return result;
};
var exponential = (stop, unit, start = 0)=>{
    const result = {};
    for(; start <= stop; start = start * 2 || 1)result[start] = start + unit;
    return result;
};
var linear = (stop, unit = "", divideBy = 1, start = 0, step = 1, result = {})=>{
    for(; start <= stop; start += step)result[start] = start / divideBy + unit;
    return result;
};
var alias2 = (section)=>(theme2)=>theme2(section);
var themeFactory = (args, { theme: theme2 })=>theme2(...args);
var theme = (...args)=>directive(themeFactory, args);
var defaultTheme = {
    screens: {
        sm: "640px",
        md: "768px",
        lg: "1024px",
        xl: "1280px",
        "2xl": "1536px"
    },
    colors: {
        transparent: "transparent",
        current: "currentColor",
        black: "#000",
        white: "#fff",
        gray: {
            50: "#f9fafb",
            100: "#f3f4f6",
            200: "#e5e7eb",
            300: "#d1d5db",
            400: "#9ca3af",
            500: "#6b7280",
            600: "#4b5563",
            700: "#374151",
            800: "#1f2937",
            900: "#111827"
        },
        red: {
            50: "#fef2f2",
            100: "#fee2e2",
            200: "#fecaca",
            300: "#fca5a5",
            400: "#f87171",
            500: "#ef4444",
            600: "#dc2626",
            700: "#b91c1c",
            800: "#991b1b",
            900: "#7f1d1d"
        },
        yellow: {
            50: "#fffbeb",
            100: "#fef3c7",
            200: "#fde68a",
            300: "#fcd34d",
            400: "#fbbf24",
            500: "#f59e0b",
            600: "#d97706",
            700: "#b45309",
            800: "#92400e",
            900: "#78350f"
        },
        green: {
            50: "#ecfdf5",
            100: "#d1fae5",
            200: "#a7f3d0",
            300: "#6ee7b7",
            400: "#34d399",
            500: "#10b981",
            600: "#059669",
            700: "#047857",
            800: "#065f46",
            900: "#064e3b"
        },
        blue: {
            50: "#eff6ff",
            100: "#dbeafe",
            200: "#bfdbfe",
            300: "#93c5fd",
            400: "#60a5fa",
            500: "#3b82f6",
            600: "#2563eb",
            700: "#1d4ed8",
            800: "#1e40af",
            900: "#1e3a8a"
        },
        indigo: {
            50: "#eef2ff",
            100: "#e0e7ff",
            200: "#c7d2fe",
            300: "#a5b4fc",
            400: "#818cf8",
            500: "#6366f1",
            600: "#4f46e5",
            700: "#4338ca",
            800: "#3730a3",
            900: "#312e81"
        },
        purple: {
            50: "#f5f3ff",
            100: "#ede9fe",
            200: "#ddd6fe",
            300: "#c4b5fd",
            400: "#a78bfa",
            500: "#8b5cf6",
            600: "#7c3aed",
            700: "#6d28d9",
            800: "#5b21b6",
            900: "#4c1d95"
        },
        pink: {
            50: "#fdf2f8",
            100: "#fce7f3",
            200: "#fbcfe8",
            300: "#f9a8d4",
            400: "#f472b6",
            500: "#ec4899",
            600: "#db2777",
            700: "#be185d",
            800: "#9d174d",
            900: "#831843"
        }
    },
    spacing: {
        px: "1px",
        0: "0px",
        .../* @__PURE__ */ linear(4, "rem", 4, 0.5, 0.5),
        .../* @__PURE__ */ linear(12, "rem", 4, 5),
        14: "3.5rem",
        .../* @__PURE__ */ linear(64, "rem", 4, 16, 4),
        72: "18rem",
        80: "20rem",
        96: "24rem"
    },
    durations: {
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
    },
    animation: {
        none: "none",
        spin: "spin 1s linear infinite",
        ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
        pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
        bounce: "bounce 1s infinite"
    },
    backdropBlur: /* @__PURE__ */ alias2("blur"),
    backdropBrightness: /* @__PURE__ */ alias2("brightness"),
    backdropContrast: /* @__PURE__ */ alias2("contrast"),
    backdropGrayscale: /* @__PURE__ */ alias2("grayscale"),
    backdropHueRotate: /* @__PURE__ */ alias2("hueRotate"),
    backdropInvert: /* @__PURE__ */ alias2("invert"),
    backdropOpacity: /* @__PURE__ */ alias2("opacity"),
    backdropSaturate: /* @__PURE__ */ alias2("saturate"),
    backdropSepia: /* @__PURE__ */ alias2("sepia"),
    backgroundColor: /* @__PURE__ */ alias2("colors"),
    backgroundImage: {
        none: "none"
    },
    backgroundOpacity: /* @__PURE__ */ alias2("opacity"),
    backgroundSize: {
        auto: "auto",
        cover: "cover",
        contain: "contain"
    },
    blur: {
        0: "0",
        sm: "4px",
        DEFAULT: "8px",
        md: "12px",
        lg: "16px",
        xl: "24px",
        "2xl": "40px",
        "3xl": "64px"
    },
    brightness: {
        .../* @__PURE__ */ linear(200, "", 100, 0, 50),
        .../* @__PURE__ */ linear(110, "", 100, 90, 5),
        75: "0.75",
        125: "1.25"
    },
    borderColor: (theme2)=>({
            ...theme2("colors"),
            DEFAULT: theme2("colors.gray.200", "currentColor")
        }),
    borderOpacity: /* @__PURE__ */ alias2("opacity"),
    borderRadius: {
        none: "0px",
        sm: "0.125rem",
        DEFAULT: "0.25rem",
        md: "0.375rem",
        lg: "0.5rem",
        xl: "0.75rem",
        "2xl": "1rem",
        "3xl": "1.5rem",
        "1/2": "50%",
        full: "9999px"
    },
    borderWidth: {
        DEFAULT: "1px",
        .../* @__PURE__ */ exponential(8, "px")
    },
    boxShadow: {
        sm: "0 1px 2px 0 rgba(0,0,0,0.05)",
        DEFAULT: "0 1px 3px 0 rgba(0,0,0,0.1), 0 1px 2px 0 rgba(0,0,0,0.06)",
        md: "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)",
        lg: "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)",
        xl: "0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)",
        "2xl": "0 25px 50px -12px rgba(0,0,0,0.25)",
        inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
        none: "none"
    },
    contrast: {
        .../* @__PURE__ */ linear(200, "", 100, 0, 50),
        75: "0.75",
        125: "1.25"
    },
    divideColor: /* @__PURE__ */ alias2("borderColor"),
    divideOpacity: /* @__PURE__ */ alias2("borderOpacity"),
    divideWidth: /* @__PURE__ */ alias2("borderWidth"),
    dropShadow: {
        sm: "0 1px 1px rgba(0,0,0,0.05)",
        DEFAULT: [
            "0 1px 2px rgba(0,0,0,0.1)",
            "0 1px 1px rgba(0,0,0,0.06)"
        ],
        md: [
            "0 4px 3px rgba(0,0,0,0.07)",
            "0 2px 2px rgba(0,0,0,0.06)"
        ],
        lg: [
            "0 10px 8px rgba(0,0,0,0.04)",
            "0 4px 3px rgba(0,0,0,0.1)"
        ],
        xl: [
            "0 20px 13px rgba(0,0,0,0.03)",
            "0 8px 5px rgba(0,0,0,0.08)"
        ],
        "2xl": "0 25px 25px rgba(0,0,0,0.15)",
        none: "0 0 #0000"
    },
    fill: {
        current: "currentColor"
    },
    grayscale: {
        0: "0",
        DEFAULT: "100%"
    },
    hueRotate: {
        0: "0deg",
        15: "15deg",
        30: "30deg",
        60: "60deg",
        90: "90deg",
        180: "180deg"
    },
    invert: {
        0: "0",
        DEFAULT: "100%"
    },
    flex: {
        1: "1 1 0%",
        auto: "1 1 auto",
        initial: "0 1 auto",
        none: "none"
    },
    fontFamily: {
        sans: 'ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"'.split(","),
        serif: 'ui-serif,Georgia,Cambria,"Times New Roman",Times,serif'.split(","),
        mono: 'ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'.split(",")
    },
    fontSize: {
        xs: [
            "0.75rem",
            "1rem"
        ],
        sm: [
            "0.875rem",
            "1.25rem"
        ],
        base: [
            "1rem",
            "1.5rem"
        ],
        lg: [
            "1.125rem",
            "1.75rem"
        ],
        xl: [
            "1.25rem",
            "1.75rem"
        ],
        "2xl": [
            "1.5rem",
            "2rem"
        ],
        "3xl": [
            "1.875rem",
            "2.25rem"
        ],
        "4xl": [
            "2.25rem",
            "2.5rem"
        ],
        "5xl": [
            "3rem",
            "1"
        ],
        "6xl": [
            "3.75rem",
            "1"
        ],
        "7xl": [
            "4.5rem",
            "1"
        ],
        "8xl": [
            "6rem",
            "1"
        ],
        "9xl": [
            "8rem",
            "1"
        ]
    },
    fontWeight: {
        thin: "100",
        extralight: "200",
        light: "300",
        normal: "400",
        medium: "500",
        semibold: "600",
        bold: "700",
        extrabold: "800",
        black: "900"
    },
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridAutoColumns: {
        min: "min-content",
        max: "max-content",
        fr: "minmax(0,1fr)"
    },
    gridAutoRows: {
        min: "min-content",
        max: "max-content",
        fr: "minmax(0,1fr)"
    },
    gridColumn: {
        auto: "auto",
        "span-full": "1 / -1"
    },
    gridRow: {
        auto: "auto",
        "span-full": "1 / -1"
    },
    gap: /* @__PURE__ */ alias2("spacing"),
    gradientColorStops: /* @__PURE__ */ alias2("colors"),
    height: (theme2)=>({
            auto: "auto",
            ...theme2("spacing"),
            ...ratios(2, 6),
            full: "100%",
            screen: "100vh"
        }),
    inset: (theme2)=>({
            auto: "auto",
            ...theme2("spacing"),
            ...ratios(2, 4),
            full: "100%"
        }),
    keyframes: {
        spin: {
            from: {
                transform: "rotate(0deg)"
            },
            to: {
                transform: "rotate(360deg)"
            }
        },
        ping: {
            "0%": {
                transform: "scale(1)",
                opacity: "1"
            },
            "75%,100%": {
                transform: "scale(2)",
                opacity: "0"
            }
        },
        pulse: {
            "0%,100%": {
                opacity: "1"
            },
            "50%": {
                opacity: ".5"
            }
        },
        bounce: {
            "0%, 100%": {
                transform: "translateY(-25%)",
                animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
            },
            "50%": {
                transform: "none",
                animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
            }
        }
    },
    letterSpacing: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0em",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
    },
    lineHeight: {
        none: "1",
        tight: "1.25",
        snug: "1.375",
        normal: "1.5",
        relaxed: "1.625",
        loose: "2",
        .../* @__PURE__ */ linear(10, "rem", 4, 3)
    },
    margin: (theme2)=>({
            auto: "auto",
            ...theme2("spacing")
        }),
    maxHeight: (theme2)=>({
            ...theme2("spacing"),
            full: "100%",
            screen: "100vh"
        }),
    maxWidth: (theme2, { breakpoints })=>({
            none: "none",
            0: "0rem",
            xs: "20rem",
            sm: "24rem",
            md: "28rem",
            lg: "32rem",
            xl: "36rem",
            "2xl": "42rem",
            "3xl": "48rem",
            "4xl": "56rem",
            "5xl": "64rem",
            "6xl": "72rem",
            "7xl": "80rem",
            full: "100%",
            min: "min-content",
            max: "max-content",
            prose: "65ch",
            ...breakpoints(theme2("screens"))
        }),
    minHeight: {
        0: "0px",
        full: "100%",
        screen: "100vh"
    },
    minWidth: {
        0: "0px",
        full: "100%",
        min: "min-content",
        max: "max-content"
    },
    opacity: {
        .../* @__PURE__ */ linear(100, "", 100, 0, 10),
        5: "0.05",
        25: "0.25",
        75: "0.75",
        95: "0.95"
    },
    order: {
        first: "-9999",
        last: "9999",
        none: "0",
        .../* @__PURE__ */ linear(12, "", 1, 1)
    },
    outline: {
        none: [
            "2px solid transparent",
            "2px"
        ],
        white: [
            "2px dotted white",
            "2px"
        ],
        black: [
            "2px dotted black",
            "2px"
        ]
    },
    padding: /* @__PURE__ */ alias2("spacing"),
    placeholderColor: /* @__PURE__ */ alias2("colors"),
    placeholderOpacity: /* @__PURE__ */ alias2("opacity"),
    ringColor: (theme2)=>({
            DEFAULT: theme2("colors.blue.500", "#3b82f6"),
            ...theme2("colors")
        }),
    ringOffsetColor: /* @__PURE__ */ alias2("colors"),
    ringOffsetWidth: /* @__PURE__ */ exponential(8, "px"),
    ringOpacity: (theme2)=>({
            DEFAULT: "0.5",
            ...theme2("opacity")
        }),
    ringWidth: {
        DEFAULT: "3px",
        .../* @__PURE__ */ exponential(8, "px")
    },
    rotate: {
        .../* @__PURE__ */ exponential(2, "deg"),
        .../* @__PURE__ */ exponential(12, "deg", 3),
        .../* @__PURE__ */ exponential(180, "deg", 45)
    },
    saturate: /* @__PURE__ */ linear(200, "", 100, 0, 50),
    scale: {
        .../* @__PURE__ */ linear(150, "", 100, 0, 50),
        .../* @__PURE__ */ linear(110, "", 100, 90, 5),
        75: "0.75",
        125: "1.25"
    },
    sepia: {
        0: "0",
        DEFAULT: "100%"
    },
    skew: {
        .../* @__PURE__ */ exponential(2, "deg"),
        .../* @__PURE__ */ exponential(12, "deg", 3)
    },
    space: /* @__PURE__ */ alias2("spacing"),
    stroke: {
        current: "currentColor"
    },
    strokeWidth: /* @__PURE__ */ linear(2),
    textColor: /* @__PURE__ */ alias2("colors"),
    textOpacity: /* @__PURE__ */ alias2("opacity"),
    transitionDuration: (theme2)=>({
            DEFAULT: "150ms",
            ...theme2("durations")
        }),
    transitionDelay: /* @__PURE__ */ alias2("durations"),
    transitionProperty: {
        none: "none",
        all: "all",
        DEFAULT: "background-color,border-color,color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter",
        colors: "background-color,border-color,color,fill,stroke",
        opacity: "opacity",
        shadow: "box-shadow",
        transform: "transform"
    },
    transitionTimingFunction: {
        DEFAULT: "cubic-bezier(0.4,0,0.2,1)",
        linear: "linear",
        in: "cubic-bezier(0.4,0,1,1)",
        out: "cubic-bezier(0,0,0.2,1)",
        "in-out": "cubic-bezier(0.4,0,0.2,1)"
    },
    translate: (theme2)=>({
            ...theme2("spacing"),
            ...ratios(2, 4),
            full: "100%"
        }),
    width: (theme2)=>({
            auto: "auto",
            ...theme2("spacing"),
            ...ratios(2, 6),
            ...ratios(12, 12),
            screen: "100vw",
            full: "100%",
            min: "min-content",
            max: "max-content"
        }),
    zIndex: {
        auto: "auto",
        .../* @__PURE__ */ linear(50, "", 1, 0, 10)
    }
};
var flattenColorPalette = (colors, target = {}, prefix = [])=>{
    Object.keys(colors).forEach((property2)=>{
        const value = colors[property2];
        if (property2 == "DEFAULT") {
            target[join(prefix)] = value;
            target[join(prefix, ".")] = value;
        }
        const key = [
            ...prefix,
            property2
        ];
        target[join(key)] = value;
        target[join(key, ".")] = value;
        if (value && typeof value == "object") flattenColorPalette(value, target, key);
    }, target);
    return target;
};
var resolveContext = {
    negative: ()=>({}),
    breakpoints: (screens)=>Object.keys(screens).filter((key)=>typeof screens[key] == "string").reduce((target, key)=>{
            target["screen-" + key] = screens[key];
            return target;
        }, {})
};
var handleArbitraryValues = (section, key)=>(key = key[0] == "[" && key.slice(-1) == "]" && key.slice(1, -1)) && includes(section, "olor") == /^(#|(hsl|rgb)a?\(|[a-z]+$)/.test(key) && (includes(key, "calc(") ? key.replace(/(-?\d*\.?\d(?!\b-.+[,)](?![^+\-/*])\D)(?:%|[a-z]+)?|\))([+\-/*])/g, "$1 $2 ") : key);
var makeThemeResolver = (config)=>{
    const cache = new Map();
    const theme2 = {
        ...defaultTheme,
        ...config
    };
    const deref = (theme3, section)=>{
        const base = theme3 && theme3[section];
        const value = typeof base == "function" ? base(resolve, resolveContext) : base;
        return value && section == "colors" ? flattenColorPalette(value) : value;
    };
    const resolve = (section, key, defaultValue)=>{
        const keypath = section.split(".");
        section = keypath[0];
        if (keypath.length > 1) {
            defaultValue = key;
            key = join(tail(keypath), ".");
        }
        let base = cache.get(section);
        if (!base) {
            cache.set(section, base = {
                ...deref(theme2, section)
            });
            Object.assign(base, deref(theme2.extend, section));
        }
        if (key != null) {
            key = (Array.isArray(key) ? join(key) : key) || "DEFAULT";
            const value = handleArbitraryValues(section, key) || base[key];
            return value == null ? defaultValue : Array.isArray(value) && !includes([
                "fontSize",
                "outline",
                "dropShadow"
            ], section) ? join(value, ",") : value;
        }
        return base;
    };
    return resolve;
};
// src/twind/translate.ts
var translate = (plugins, context)=>(rule, isTranslating)=>{
        if (typeof rule.d == "function") return rule.d(context);
        const parameters = rule.d.split(/-(?![^[]*])/g);
        if (!isTranslating && parameters[0] == "tw" && rule.$ == rule.d) return rule.$;
        for(let index = parameters.length; index; index--){
            const id = join(parameters.slice(0, index));
            if (Object.prototype.hasOwnProperty.call(plugins, id)) {
                const plugin = plugins[id];
                return typeof plugin == "function" ? plugin(tail(parameters, index), context, id) : typeof plugin == "string" ? context[isTranslating ? "css" : "tw"](plugin) : plugin;
            }
        }
    };
// src/twind/decorate.ts
var _2;
var GROUP_RE = /^:(group(?:(?!-focus).+?)*)-(.+)$/;
var NOT_PREFIX_RE = /^(:not)-(.+)/;
var prepareVariantSelector = (variant)=>variant[1] == "[" ? tail(variant) : variant;
var decorate = (darkMode, variants, { theme: theme2, tag })=>{
    const applyVariant = (translation, variant)=>{
        if (_2 = theme2("screens", tail(variant), "")) return {
            [buildMediaQuery(_2)]: translation
        };
        if (variant == ":dark" && darkMode == "class") return {
            ".dark &": translation
        };
        if (_2 = GROUP_RE.exec(variant)) return {
            [`.${escape(tag(_2[1]))}:${_2[2]} &`]: translation
        };
        return {
            [variants[tail(variant)] || "&" + variant.replace(NOT_PREFIX_RE, (_4, not, variant2)=>not + "(" + prepareVariantSelector(":" + variant2) + ")")]: translation
        };
    };
    return (translation, rule)=>rule.v.reduceRight(applyVariant, translation);
};
// src/twind/presedence.ts
var _3;
var responsivePrecedence = (css)=>(((_3 = /(?:^|min-width: *)(\d+(?:.\d+)?)(p)?/.exec(css)) ? +_3[1] / (_3[2] ? 15 : 1) / 10 : 0) & 31) << 22;
var seperatorPrecedence = (string)=>{
    _3 = 0;
    for(let index = string.length; index--;)_3 += includes("-:,", string[index]);
    return _3;
};
var atRulePresedence = (css)=>(seperatorPrecedence(css) & 15) << 18;
var PRECEDENCES_BY_PSEUDO_CLASS = [
    "rst",
    "st",
    "en",
    "d",
    "nk",
    "sited",
    "pty",
    "ecked",
    "cus-w",
    "ver",
    "cus",
    "cus-v",
    "tive",
    "sable",
    "ad-on",
    "tiona",
    "quire"
];
var pseudoPrecedence = (pseudoClass)=>1 << (~(_3 = PRECEDENCES_BY_PSEUDO_CLASS.indexOf(pseudoClass.replace(GROUP_RE, ":$2").slice(3, 8))) ? _3 : 17);
var makeVariantPresedenceCalculator = (theme2, variants)=>(presedence, variant)=>presedence | ((_3 = theme2("screens", tail(variant), "")) ? 134217728 | responsivePrecedence(buildMediaQuery(_3)) : variant == ":dark" ? 1073741824 : (_3 = variants[variant] || variant.replace(NOT_PREFIX_RE, ":$2"))[0] == "@" ? atRulePresedence(_3) : pseudoPrecedence(variant));
var declarationPropertyPrecedence = (property2)=>property2[0] == "-" ? 0 : seperatorPrecedence(property2) + ((_3 = /^(?:(border-(?!w|c|sty)|[tlbr].{2,4}m?$|c.{7}$)|([fl].{5}l|g.{8}$|pl))/.exec(property2)) ? +!!_3[1] || -!!_3[2] : 0) + 1;
// src/twind/serialize.ts
var stringifyBlock = (body, selector)=>selector + "{" + body + "}";
var serialize = (prefix, variants, context)=>{
    const { theme: theme2, tag } = context;
    const tagVar = (_4, property2)=>"--" + tag(property2);
    const tagVars = (value)=>`${value}`.replace(/--(tw-[\w-]+)\b/g, tagVar);
    const stringifyDeclaration = (property2, value, important)=>{
        property2 = tagVars(property2);
        return Array.isArray(value) ? join(value.filter(Boolean).map((value2)=>prefix(property2, tagVars(value2), important)), ";") : prefix(property2, tagVars(value), important);
    };
    let rules2;
    const stringify2 = (atRules, selector, presedence, css, important)=>{
        if (Array.isArray(css)) {
            css.forEach((css2)=>css2 && stringify2(atRules, selector, presedence, css2, important));
            return;
        }
        let declarations = "";
        let maxPropertyPresedence = 0;
        let numberOfDeclarations = 0;
        if (css["@apply"]) css = merge(evalThunk(apply(css["@apply"]), context), {
            ...css,
            "@apply": void 0
        }, context);
        Object.keys(css).forEach((key)=>{
            const value = evalThunk(css[key], context);
            if (isCSSProperty(key, value)) {
                if (value !== "" && key.length > 1) {
                    const property2 = hyphenate(key);
                    numberOfDeclarations += 1;
                    maxPropertyPresedence = Math.max(maxPropertyPresedence, declarationPropertyPrecedence(property2));
                    declarations = (declarations && declarations + ";") + stringifyDeclaration(property2, value, important);
                }
            } else if (value) {
                if (key == ":global") key = "@global";
                if (key[0] == "@") {
                    if (key[1] == "g") stringify2([], "", 0, value, important);
                    else if (key[1] == "f") stringify2([], key, 0, value, important);
                    else if (key[1] == "k") {
                        const currentSize = rules2.length;
                        stringify2([], "", 0, value, important);
                        const waypoints = rules2.splice(currentSize, rules2.length - currentSize);
                        rules2.push({
                            r: stringifyBlock(join(waypoints.map((p)=>p.r), ""), key),
                            p: waypoints.reduce((sum, p)=>sum + p.p, 0)
                        });
                    } else if (key[1] == "i") (Array.isArray(value) ? value : [
                        value
                    ]).forEach((value2)=>value2 && rules2.push({
                            p: 0,
                            r: `${key} ${value2};`
                        }));
                    else {
                        if (key[2] == "c") key = buildMediaQuery(context.theme("screens", tail(key, 8).trim()));
                        stringify2([
                            ...atRules,
                            key
                        ], selector, presedence | responsivePrecedence(key) | atRulePresedence(key), value, important);
                    }
                } else stringify2(atRules, selector ? selector.replace(/ *((?:\(.+?\)|\[.+?\]|[^,])+) *(,|$)/g, (_4, selectorPart, comma)=>key.replace(/ *((?:\(.+?\)|\[.+?\]|[^,])+) *(,|$)/g, (_5, keyPart, comma2)=>(includes(keyPart, "&") ? keyPart.replace(/&/g, selectorPart) : (selectorPart && selectorPart + " ") + keyPart) + comma2) + comma) : key, presedence, value, important);
            }
        });
        if (numberOfDeclarations) rules2.push({
            r: atRules.reduceRight(stringifyBlock, stringifyBlock(declarations, selector)),
            p: presedence * 256 + ((Math.max(0, 15 - numberOfDeclarations) & 15) << 4 | (maxPropertyPresedence || 15) & 15)
        });
    };
    const variantPresedence = makeVariantPresedenceCalculator(theme2, variants);
    return (css, className, rule, layer = 0)=>{
        layer <<= 28;
        rules2 = [];
        stringify2([], className ? "." + escape(className) : "", rule ? rule.v.reduceRight(variantPresedence, layer) : layer, css, rule && rule.i);
        return rules2;
    };
};
// src/twind/inject.ts
var inject = (sheet, mode2, init, context)=>{
    let sortedPrecedences;
    init((value = [])=>sortedPrecedences = value);
    let insertedRules;
    init((value = new Set())=>insertedRules = value);
    return ({ r: css, p: presedence })=>{
        if (!insertedRules.has(css)) {
            insertedRules.add(css);
            const index = sortedInsertionIndex(sortedPrecedences, presedence);
            try {
                sheet.insert(css, index);
                sortedPrecedences.splice(index, 0, presedence);
            } catch (error) {
                if (!/:-[mwo]/.test(css)) mode2.report({
                    id: "INJECT_CSS_ERROR",
                    css,
                    error
                }, context);
            }
        }
    };
};
// src/twind/configure.ts
var sanitize = (value, defaultValue, disabled, enabled = defaultValue)=>value === false ? disabled : value === true ? enabled : value || defaultValue;
var loadMode = (mode2)=>(typeof mode2 == "string" ? ({
        t: strict,
        a: warn,
        i: silent
    })[mode2[1]] : mode2) || warn;
var COMPONENT_PROPS = {
    _: {
        value: "",
        writable: true
    }
};
var configure = (config = {})=>{
    const theme2 = makeThemeResolver(config.theme);
    const mode2 = loadMode(config.mode);
    const hash = sanitize(config.hash, false, false, cyrb32);
    const important = config.important;
    let activeRule = {
        v: []
    };
    let translateDepth = 0;
    const lastTranslations = [];
    const context = {
        tw: (...tokens)=>process(tokens),
        theme: (section, key, defaultValue)=>{
            var _a;
            const value = (_a = theme2(section, key, defaultValue)) != null ? _a : mode2.unknown(section, key == null || Array.isArray(key) ? key : key.split("."), defaultValue != null, context);
            return activeRule.n && value && includes("rg", (typeof value)[5]) ? `calc(${value} * -1)` : value;
        },
        tag: (value)=>hash ? hash(value) : value,
        css: (rules2)=>{
            translateDepth++;
            const lastTranslationsIndex = lastTranslations.length;
            try {
                (typeof rules2 == "string" ? parse([
                    rules2
                ]) : rules2).forEach(convert);
                const css = Object.create(null, COMPONENT_PROPS);
                for(let index = lastTranslationsIndex; index < lastTranslations.length; index++){
                    const translation = lastTranslations[index];
                    if (translation) switch(typeof translation){
                        case "object":
                            merge(css, translation, context);
                            break;
                        case "string":
                            css._ += (css._ && " ") + translation;
                    }
                }
                return css;
            } finally{
                lastTranslations.length = lastTranslationsIndex;
                translateDepth--;
            }
        }
    };
    const translate2 = translate({
        ...corePlugins,
        ...config.plugins
    }, context);
    const doTranslate = (rule)=>{
        const parentRule = activeRule;
        activeRule = rule;
        try {
            return evalThunk(translate2(rule), context);
        } finally{
            activeRule = parentRule;
        }
    };
    const variants = {
        ...coreVariants,
        ...config.variants
    };
    const decorate2 = decorate(config.darkMode || "media", variants, context);
    const serialize2 = serialize(sanitize(config.prefix, autoprefix, noprefix), variants, context);
    const sheet = config.sheet || (typeof window == "undefined" ? voidSheet() : cssomSheet(config));
    const { init = (callback)=>callback() } = sheet;
    const inject2 = inject(sheet, mode2, init, context);
    let idToClassName;
    init((value = new Map())=>idToClassName = value);
    const inlineDirectiveName = new WeakMap();
    const evaluateFunctions = (key, value)=>key == "_" ? void 0 : typeof value == "function" ? JSON.stringify(evalThunk(value, context), evaluateFunctions) : value;
    const convert = (rule)=>{
        if (!translateDepth && activeRule.v.length) rule = {
            ...rule,
            v: [
                ...activeRule.v,
                ...rule.v
            ],
            $: ""
        };
        if (!rule.$) rule.$ = stringifyRule(rule, inlineDirectiveName.get(rule.d));
        let className = translateDepth ? null : idToClassName.get(rule.$);
        if (className == null) {
            let translation = doTranslate(rule);
            if (!rule.$) {
                rule.$ = cyrb32(JSON.stringify(translation, evaluateFunctions));
                inlineDirectiveName.set(rule.d, rule.$);
                rule.$ = stringifyRule(rule, rule.$);
            }
            if (translation && typeof translation == "object") {
                rule.v = rule.v.map(prepareVariantSelector);
                if (important) rule.i = important;
                translation = decorate2(translation, rule);
                if (translateDepth) lastTranslations.push(translation);
                else {
                    const layer = typeof rule.d == "function" ? typeof translation._ == "string" ? 1 : 3 : 2;
                    className = hash || typeof rule.d == "function" ? (hash || cyrb32)(layer + rule.$) : rule.$;
                    serialize2(translation, className, rule, layer).forEach(inject2);
                    if (translation._) className += " " + translation._;
                }
            } else {
                if (typeof translation == "string") className = translation;
                else {
                    className = rule.$;
                    mode2.report({
                        id: "UNKNOWN_DIRECTIVE",
                        rule: className
                    }, context);
                }
                if (translateDepth && typeof rule.d !== "function") lastTranslations.push(className);
            }
            if (!translateDepth) {
                idToClassName.set(rule.$, className);
                ensureMaxSize(idToClassName, 3e4);
            }
        }
        return className;
    };
    const process = (tokens)=>join(parse(tokens).map(convert).filter(Boolean), " ");
    const preflight = sanitize(config.preflight, identity, false);
    if (preflight) {
        const css = createPreflight(theme2);
        const styles = serialize2(typeof preflight == "function" ? evalThunk(preflight(css, context), context) || css : {
            ...css,
            ...preflight
        });
        init((injected = (styles.forEach(inject2), true))=>injected);
    }
    return {
        init: ()=>mode2.report({
                id: "LATE_SETUP_CALL"
            }, context),
        process
    };
};
// src/twind/instance.ts
var create = (config)=>{
    let process = (tokens)=>{
        init();
        return process(tokens);
    };
    let init = (config2)=>{
        ({ process, init } = configure(config2));
    };
    if (config) init(config);
    let context;
    const fromContext = (key)=>()=>{
            if (!context) process([
                (_4)=>{
                    context = _4;
                    return "";
                }
            ]);
            return context[key];
        };
    return {
        tw: Object.defineProperties((...tokens)=>process(tokens), {
            theme: {
                get: fromContext("theme")
            }
        }),
        setup: (config2)=>init(config2)
    };
};
// src/twind/default.ts
var { tw, setup } = /* @__PURE__ */ create();
// src/twind/expand.ts
var expandGroups = (classNames)=>parse(classNames).map((rule)=>stringifyRule(rule)).join(" ");

},{"style-vendorizer":"h3dBi","@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"h3dBi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cssPropertyAlias", ()=>r);
parcelHelpers.export(exports, "cssPropertyPrefixFlags", ()=>a);
parcelHelpers.export(exports, "cssValuePrefixFlags", ()=>t);
var i = new Map([
    [
        "align-self",
        "-ms-grid-row-align"
    ],
    [
        "color-adjust",
        "-webkit-print-color-adjust"
    ],
    [
        "column-gap",
        "grid-column-gap"
    ],
    [
        "forced-color-adjust",
        "-ms-high-contrast-adjust"
    ],
    [
        "gap",
        "grid-gap"
    ],
    [
        "grid-template-columns",
        "-ms-grid-columns"
    ],
    [
        "grid-template-rows",
        "-ms-grid-rows"
    ],
    [
        "justify-self",
        "-ms-grid-column-align"
    ],
    [
        "margin-inline-end",
        "-webkit-margin-end"
    ],
    [
        "margin-inline-start",
        "-webkit-margin-start"
    ],
    [
        "mask-border",
        "-webkit-mask-box-image"
    ],
    [
        "mask-border-outset",
        "-webkit-mask-box-image-outset"
    ],
    [
        "mask-border-slice",
        "-webkit-mask-box-image-slice"
    ],
    [
        "mask-border-source",
        "-webkit-mask-box-image-source"
    ],
    [
        "mask-border-repeat",
        "-webkit-mask-box-image-repeat"
    ],
    [
        "mask-border-width",
        "-webkit-mask-box-image-width"
    ],
    [
        "overflow-wrap",
        "word-wrap"
    ],
    [
        "padding-inline-end",
        "-webkit-padding-end"
    ],
    [
        "padding-inline-start",
        "-webkit-padding-start"
    ],
    [
        "print-color-adjust",
        "color-adjust"
    ],
    [
        "row-gap",
        "grid-row-gap"
    ],
    [
        "scroll-margin-bottom",
        "scroll-snap-margin-bottom"
    ],
    [
        "scroll-margin-left",
        "scroll-snap-margin-left"
    ],
    [
        "scroll-margin-right",
        "scroll-snap-margin-right"
    ],
    [
        "scroll-margin-top",
        "scroll-snap-margin-top"
    ],
    [
        "scroll-margin",
        "scroll-snap-margin"
    ],
    [
        "text-combine-upright",
        "-ms-text-combine-horizontal"
    ]
]);
function r(r) {
    return i.get(r);
}
function a(i) {
    var r = /^(?:(text-(?:decoration$|e|or|si)|back(?:ground-cl|d|f)|box-d|mask(?:$|-[ispro]|-cl)|pr|hyphena|flex-d)|(tab-|column(?!-s)|text-align-l)|(ap)|u|hy)/i.exec(i);
    return r ? r[1] ? 1 : r[2] ? 2 : r[3] ? 3 : 5 : 0;
}
function t(i, r) {
    var a = /^(?:(pos)|(cli)|(background-i)|(flex(?:$|-b)|(?:max-|min-)?(?:block-s|inl|he|widt))|dis)/i.exec(i);
    return a ? a[1] ? /^sti/i.test(r) ? 1 : 0 : a[2] ? /^pat/i.test(r) ? 1 : 0 : a[3] ? /^image-/i.test(r) ? 1 : 0 : a[4] ? "-" === r[3] ? 2 : 0 : /^(?:inline-)?grid$/i.test(r) ? 4 : 0 : 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}],"bAFmu":[function(require,module,exports,__globalThis) {
module.exports = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22897%22%20height%3D%22452%22%20viewBox%3D%220%200%20897%20452%22%3E%3Ctitle%3EIPAD%202%3C%2Ftitle%3E%3Cg%20id%3D%22Page-1%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%3E%3Cg%20id%3D%22IPAD%22%20stroke%3D%22%237e89a3%22%20transform%3D%22translate%28681%2055%29%22%3E%3Cpath%20id%3D%22bezel%22%20fill%3D%22%23fdfdfd%22%20stroke-width%3D%222%22%20d%3D%22M202.986%20317H12.097C5.462%20317%20.083%20311.623.083%20304.99V12.093c0-6.633%205.378-12.01%2012.014-12.01h190.889C209.622.083%20215%205.46%20215%2012.093V304.99c0%206.633-5.378%2012.01-12.014%2012.01Z%22%2F%3E%3Cpath%20id%3D%22bezel-2%22%20fill%3D%22%23fdfdfd%22%20stroke-width%3D%222%22%20d%3D%22M202.986%20317H12.097C5.462%20317%20.083%20311.623.083%20304.99V12.093c0-6.633%205.378-12.01%2012.014-12.01h190.889C209.622.083%20215%205.46%20215%2012.093V304.99c0%206.633-5.378%2012.01-12.014%2012.01Z%22%2F%3E%3Cpath%20id%3D%22screen%22%20fill%3D%22%23fff%22%20d%3D%22M17%2032h181.999v252.917H17Z%22%2F%3E%3Ccircle%20id%3D%22lock%22%20cx%3D%22108.021%22%20cy%3D%22300.021%22%20r%3D%228.021%22%2F%3E%3Ccircle%20id%3D%22camera%22%20cx%3D%22106.99%22%20cy%3D%2216.99%22%20r%3D%222.99%22%2F%3E%3C%2Fg%3E%3Cg%20id%3D%22Laptop%22%20stroke%3D%22%238492a5%22%20transform%3D%22translate%281%201%29%22%3E%3Cpath%20id%3D%22bezel%22%20fill%3D%22%23fefefe%22%20stroke-width%3D%222%22%20d%3D%22M594%200H98C84.504%200%2073%2011.074%2073%2024.79v326.238h546V24.79C619%2011.073%20607.537%200%20594%200Z%22%2F%3E%3Ccircle%20id%3D%22webcam%22%20cx%3D%22347%22%20cy%3D%2219%22%20r%3D%224%22%20stroke-width%3D%222%22%2F%3E%3Cg%20id%3D%22bottom%22%20transform%3D%22translate%280%20351%29%22%3E%3Cpath%20id%3D%22Shape%22%20fill%3D%22%23fdfdfd%22%20stroke-width%3D%222%22%20d%3D%22M640.812%2031.01H51.288C20.641%2031.01%200%2020.494%200%2016.022V2.428c0-1.344%201.335-2.428%202.995-2.428h686.109c1.662%200%202.999%201.084%202.999%202.428v14.129c-.007%203.535-15.991%2014.453-51.291%2014.453Z%22%2F%3E%3Cpath%20id%3D%22Line%22%20stroke-linecap%3D%22square%22%20d%3D%22M.5%2014.5h689.743%22%2F%3E%3C%2Fg%3E%3Cpath%20id%3D%22screen%22%20fill%3D%22%23fff%22%20d%3D%22M95%2039h501.074v292.009H95Z%22%2F%3E%3Cpath%20id%3D%22touchpad%22%20fill%3D%22%23fff%22%20d%3D%22M421%20352v3.087c0%202.201-4.333%202.866-7.613%202.866H278.815c-3.45%200-7.815-.664-7.815-2.866V352%22%2F%3E%3C%2Fg%3E%3Cg%20id%3D%22iphone%22%20stroke%3D%22%237e89a3%22%20transform%3D%22translate%28576%20177%29%22%3E%3Cpath%20id%3D%22bezel%22%20fill%3D%22%23fdfdfd%22%20stroke-width%3D%222%22%20d%3D%22M130%20257.964c0%208.833-7.191%2015.992-16.062%2015.992H16.063c-8.871%200-16.062-7.159-16.062-15.992V16.073C.001%207.24%207.192.081%2016.063.081h97.875C122.809.081%20130%207.24%20130%2016.073v241.891Z%22%2F%3E%3Cpath%20id%3D%22screen%22%20fill%3D%22%23fff%22%20d%3D%22M9%2036h111.93v199.084H9Z%22%2F%3E%3Cpath%20id%3D%22speaker%22%20d%3D%22M77%2025.746c0%20.635-.439%201.147-.98%201.147H55.918c-.542%200-.98-.513-.98-1.147v-2.58c0-.635.439-1.147.98-1.147H76.02c.541%200%20.98.513.98%201.147v2.58Z%22%2F%3E%3Ccircle%20id%3D%22camera%22%20cx%3D%2266%22%20cy%3D%2212%22%20r%3D%223%22%2F%3E%3Cellipse%20id%3D%22lock%22%20cx%3D%2265.04%22%20cy%3D%22254.001%22%20rx%3D%2210.04%22%20ry%3D%2210.001%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E";

},{}],"3THnn":[function(require,module,exports,__globalThis) {
module.exports = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20xml%3Aspace%3D%22preserve%22%20viewBox%3D%220%200%201556%20849%22%3E%3Cimage%20xlink%3Ahref%3D%22data%3Aimage%2Fpng%3Bbase64%2CiVBORw0KGgoAAAANSUhEUgAABhQAAANRCAMAAAA8n6Y%2BAAAABGdBTUEAALGPC%2FxhBQAAACBjSFJN%20AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAArlBMVEUAAAD4%2BP%2F09P%2Fx8P%2Fq%207P%2Fn6v%2Fj5v%2Fe4v%2Fa3v%2FZ3f%2Fd3v%2Fh5P%2Fl6P%2Fp6v%2Fu8P%2Fx8v%2Fy9P%2Fd4P%2Ft7v%2F29v%2F3%2BP%2Fl5v%2Fh4v%2Ft%207P%2F49%2F%2Fs6v%2Fo5v%2Fl4v%2Fh4P%2Fg3P%2Fe2v%2Fd3P%2Fh3v%2Fk4f%2F08v%2Fo5f%2Fp6P%2Fw7v%2Fl5P%2Fs6f%2F1%2Bv%2Fy%2Bv%2Fp%209v%2Fl9P%2Fg8v%2Fe8v%2FZ8P%2FY7%2F%2FW7%2F%2Fc8f%2Fi9P%2Ft%2BP%2Fw%2Bf%2F2%2FP%2Fn9v%2Fs9%2F%2Fa2v%2F%2F%2F%2F%2B%2BG2HIAAAAAXRS%20TlMAQObYZgAAAAFiS0dEOdcAlUAAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAHdElNRQfjBR4SASQe%20mM7eAAAgY0lEQVR42u3di1ZTy7IAUCEeHwiGTQQUUdSNHHxvxXP1%2F7%2FsbnwCBshaWZ3q6sz5BaQc%20o8pe1VV94wYAAAAAAAAAAAAAAMxuZXV08z%2B3bt%2B5%2B8va7XvrGzfvj1ej%2FzQAFmdlfPPemVowxZ1b%20Nzej%2F0oAihtt3Ls7o7%2FWtybRfy4ApUxu3p61IPw6MqyPo%2F9qAIa3evOvrhXhh3s3NRkAWjJe71sR%20fh4Y7kf%2FBAAG8aD7V6Mp1jY0GADSu39rgIrw4zuS4wJAZqsbd%2BavBWc%2FI21oLwAktbk9aEX4cVxw%20HQkgofFw342UBYDcxjPPqCkLAI0blSwJp25tRv9EAGYzKfXh6KztzeifCcAMbi6gJHwrCyvRvxSA%20a4yHmFSbzR1zCwBVe7C%2BsJLgsABQua1hZ9UcFgDyerCIBrPDAkAK9xd9THBYAKjWYrsJDgsAFRvP%2092CCwwJAQzYCS8KpjegAAPDTSumtFte7Fx0DAL7bjPx09NMdS%2FIAarAVXQ9%2BuBkdCAACbx1ddCs6%20FADL7kF8O%2BG3v6KjAbDcxmvRheC8SXRAAJbYKLoIqAoA1bgfXQJUBYBq1HLtSFUAiFdnTVAVACLU%20WhNUBYDFq7cmqAoAizaOTvyqAkA1JtFpX1UAqMZKdNK%2FVnSEAJZIdMq%2Fno0XAItSw6rs6%2FwnOkgA%20S%2BJWdMKfiSc6ARZhOzrdz2gzOlAAS%2BB2dLKf2YPoUAE0L09NuLsTHSuA1iWqCXfvbkdHC6BtqWrC%203btb0fECaFlNb2%2FOxGQzQDHr0Tm%2Bs1vRIQNoVs2LUS%2FjAxJAGfU9yDyDO%2B6lApRQ97LsS7mBBFDA%20ZnR278u6C4DBrWRYgjfVnZXo2AE0J91l1N98QAIY2EZ0Zp%2FHanT0ANqS8TLqb44KAENK22T%2BwVEB%20YEBpm8w%2FOCoADCffdouLHBUAhpK7ofCNowLAQLI3FL5xVAAYRvaGwjeOCgCDSD2h8JujAsAAJtHZ%20fCAb0YEEaMF2dDYfyF%2FRgQRoQMo3FKbajA4lQH63o3P5YHw%2FAphXAyMKP%2Fl%2BBDCvJq6j%2FrAZHUyA%205Bo6KNy9%2B5%2FoaAIk19JBwfcjgPk0dVC4e3ccHU%2BA1Jo6KLh%2FBDCX%2B9FZfGA70QEFyGwnOosPLTqg%20AImNo3P44DQVAHprZevRbzejQwqQVivrUc%2B4Fx1TgLQaeUfhnOiYAqTVziq837y0A9DPanQCL0FT%20AaCfFr8e3b0VHVWApFr8eqSpANBPk1%2BPTCoA9HMzOn2XsR4dV4CU7kWn7zLWouMKkFJ09i5lEh1Y%20gITa23v0g0upAN01eSH11O3oyAIk1NzW7F%2BiIwuQUHTqLkdTAaCrlejUXc796NgCpNNsn9lDzQDd%20bUWn7nK8qQDQ1Xp06i7nTnRsAdJp9%2FKR60cAnd2JztwFuX4E0FF04i7JolSAbh5EJ%2B6StqKjC5DM%20ZnTiLsmdVIBu7kcn7pK2o6MLkEyz6%2FBOGVQA6GY7OnGX9Fd0dAGSafTZtR%2BiowuQjKIAwC%2BKAgC%2F%20KAoA%2FKIoAPBL20VhJTq8ALm0XRQeRIcXIJeGn1O4a00qQEdNTzT7fATQzc3ovF1UdHQBkmn4iWZF%20AaCrcXTeLskjzQDdNP2egoV4AN00%2FfLaTnR0AbKJTtwleU8BoKO%2FojN3QevRwQXIpuWR5t3o4AJk%2085%2FozF3Q%2FejgAmTT8qDCZnRwAbJp%2BU6qLRcAXUVn7oKiQwuQT7vXjww0A3TW7vLs7ejQAuRzPzp3%20F7MVHVqAfCbRubsYT%2BwAdBedu4uJDixARq3ONNt8BNBDq%2BNrG9GBBcio1abCODqwACntRKfvIkwp%20APRyMzp%2FF2FKAaCXNr8fWZEK0M%2Ft6AReQnRQAbJq8fuRC6kAPbW4PtuOC4C%2BGtyUGh1SgLza25S6%20Hh1SgLzG0Tl8cJvRIQVILDqHD%2B12dEABMrsVncUHps0MMIfWluJFxxMgtQfRWXxYFqQCzKWtRxUe%20RIcTILemXmp2UACY053oTD4gBwWAOTU0v%2BagADCvhubXHBQA5tbM%2FqOb0ZEEaMBGdDIfyF%2FRgQRo%20QSujCoaZAYbQRqvZ4zoAg2jjqeZxdBgBGrEdndAHsB0dRIBWNPAq5x3XUQGGkn8Bki4zwGDSD7D5%20eAQwoOxHhUl0AAFashqd1efj4xHAoFKPNft4BDCwxBuQbkfHDqA5o%2BjU3p%2BGAsDg0i67uB8dOYAG%20PUj6BJuF2QAlbEWn917Wo8MG0KiMK5DsRgUoZGUtOsV35mEdgGLy3UCKjhhAy7KNsK1EBwygaTvR%20ab4TAwoARaXagbQaHS2A1iW6l%2Br9TYDi0rQVRtGRAlgGSaYVLLe46OHkDC14YCgpms1eUPhhdbT7%20aO%2Fx%2FpOnUxw8e%2Fb88d7uCxUCmEeCLdr6CTdWxrt7%2B09ntL%2B3O34Y%2FRcDWUWn%2FGst%2BX99Vx%2F9%2FWzW%20cnCuNBy%2BVBmA7laik%2F7V7kTHJ9Jk93GfevD7k9LjR1r0QEeT6Lx%2FlZ3o6MT9s7zcO5irIvz0bM%2F3%20N6CLiofYlnUv6niv1yejS08Mew4MwOw2o3P%2FZZbznPDi8Mn8deAP6gIws3F09p%2FudnRcAqweDnpG%20OOdIXQBmU%2BUe7eV7P2H1UbmK8M2TQzukgFncj64Af1qLjsmijY%2FKVoTvHr%2BM%2Fp1ABtUtx1u2u6gv%2057t92sXei%2BgfC9Svtr5CdDwWa7fwd6OLxwXdBeBa0WXgrOW6d%2FSoxHUjZQGY063oUvDLf6JDsUj%2F%20XXhFUBaAmdyMLgY%2FLNOq7N3FnxKUBWBGdVxNXaK1DKPnYSXhW1nQcgautBq%2FSvvO8lylX13IJdQr%207S35ElrgGivRj7HdnkSHYGEOoyvCqYPd6DAAdYudWFiP%2FvkLE9hMOM83JOBKk3txNWF5Xt7ci64F%20ZxxGBwOoW9QtpJ2laSeszvy45kI8cQ8JuMrm7YiasDzTCS%2Bjq8AfHBaAK60vvCTcWZ7phCo6zBc8%20Xp4GP9DH%2FbXF1oRbS5OUJotbfdeJ9anAVVYWeVhYW55jwig6%2BV%2FKJyTgSpsLu4a0PBdRbzyKTv1X%20eL40jX6gn%2FsLGXC%2BvUR7LWpsJ5yxRP8SQC8LuJ16M%2Fo3LlBN0wlTuZsKXO1B4dbC9tI0mP8Vv%2Bvo%20WtrNwDVKthZubUb%2FukWq9NrReXYhAdcZFyoL95brE%2FZin9zsbS86TkD9xgVeZVuyknCjlgV413oe%20HSkggc2Bd2ovW0m4EZ3qOziIjhWQwWTAlvP6ZvSvWbQU%2FYSfnkRHC0hhsjHI7ovby7Mg%2B5fK5xMu%202o%2BOF5DEeH3eurC9bN%2BNTtW72%2BISR9ERA9KYoy7c2d56EP3nR3gRneO7cwcJmF2vunB7YzP67w4y%20ic7wfTyKjhqQymRrvcNipL%2FWl2cN6p%2BSDChcYLYZ6Gq8sXP9AWF9a5k2WUyR6uLRGcvY%2FAHmNhlv%203Vy%2F99edP08H99ZvjpayhXBe9UvwLvMsOnJAaiuT1c3N8fj%2B%2Fa2t%2B5uKwU%2F1vcc8M81mgKGl2W4x%20hUXaAMNK%2B%2FHo1JOV6PABNCXd1Np5f0fHD6ApOW%2Bj%2FuZeKsBwkq08mmLJrxMDDCjheouLLEECGMp%2B%20dEofgBtIAMN4FJ3Qh2CLNsAwovP5MPSaAYbQxEHBtguAYWSeZT5rNzqQAA3YjU7mQ%2FFiM8D8ss%2Bt%20%2Fea9HYB5Jd6O%2BgcrkADm9Dw6kw%2Fov9HBBEgu%2BSa883QVAOaT9Q3O6cwqAMxjNTqND%2BtxdDwBUkv9%20ts4Uq9EBBcjsIDqLD%2BwwOqAAiTXVZv4mOqIAif0dncMHZ9cFQG%2FRKXx4z6NDCpBWS9PMP72IDipA%20Vm0NKXyn1QzQz0p0Ai%2FhWXRUAZJqZmn2OZPosALkdBSdv4vYig4rQE6tPLl23t%2FRYQVIqbG9R79E%20xxUgpTZbCi6lAvTS4oXUUy6lAvQQnbxLeRYdWICEWm0peKoZoIdWWwpPn46iQwuQT6sthadPH0WH%20FiCfZ9G5uxiPcgJ0Fp26yzmIDi1APtGpu6Do0AKk0%2B7lI%2BNrAJ219zzzb97kBOio3RupT58eRQcX%20IJu96Mxd0LPo4AJk0%2B6YwlOdZoCu2h1TUBQAOovO20U9jI4uQDLRebuo1ejoAiQTnbeLshIPoJvo%20vF3Uy%2BjoAuSyEp23i7InFaCTSXTeLsqLnACdtLz6yEgzQEcvovO2ogBQj5b34T19%2Bnd0eAFyeRmd%20t4vaiw4vQC4tL0lVFAA6avuk4PYRQCdt9xQUBYBO2r6SangNoJO2h9cUBYBuovN2UR5pBugmOm8X%20ZSEeQDfRebso7ykAdHMQnbhLig4uQDbeaAbgl%2BfRibug%2FejgAmTzODpzF2TLBUBHLS8%2FMqYA0FHL%20I82j6OACpBOduQuaRMcWIJ2GmwrRoQXI51F06i7meXRoAfIZR%2BfuYizOBuguOncXo88M0F2z42sr%200ZEFSOgwOnkX8iQ6sAAZtfoi51F0YAFSis7ehZhnBuhjLzp9l%2BExBYA%2B2vx%2BZEUqQD9PohN4Cb4e%20AfTT5P2jh9FRBUiqxU2pdlwA9LUfncKHtxsdU4C0GlyKZ202QF8Po1P44B5HhxQgseYeVXgZHVGA%20xFobVXgWHVCA1Bo7KmgzA8zjRXQaH9RBdDgBkjuKTuRD%2Bm90NAGSa2qAzTQzwJwa2pW6Fx1LgPQm%200al8OJZmA8ytmbV4h9GRBGhAK2PNrh4BDGE3Op0PwzAzwCCamGCzMxtgGE1cSx1HRxGgFQ18QHId%20FWAw%2BT8geUcBYDDpPyDZhAcwoORvsP0dHT%2BAtjyPzuvzeLISHT6AtqT%2BgDSKjh5Aa7aiM3t%2F9lsA%20DC7tDqT96MgBtCjrvdQX0YEDaNHDJ9HpvRc7jwCKGEfn9z40FAAKSbju4ig6ZgDtSvc257PoiAG0%20LNsMW3S8ANq2H53m1QSAijyLTvQdWI0KUNpBdKpXEwAqEp3r1QSAmkRnezUBoCbR%2BV5NAKjISnTG%20VxMAKjKJzvnX8aoOwAI9jM76V3oSHR6AJVPzF6TH0cEBWD7Rqf9S9qICBIhO%2Fpd4FB0XgOUUnf6n%202o2OCsCyii4Af3rm7U2AMNE14KK96IAALLW6Nml7jhkgVkVvsT02xQwQ7VF0LfjJrSOACoyqeGDh%208Wp0HAA49fBxdEVwTACoyKFjAgC%2FjENvIZlXA6hMXL%2F5yKUjgOqsxnQWHo%2BjfzgA0%2BwuviQ8M64G%20UKvJ0WJLwhPNBICajRf5Dcm7CQC1e%2FlsMRXhmVMCQAa7T8qXhMej6F8JwIxKz7LtmVUDyGS33DDb%20s0cPo38dAB2NytxE2jOWAJDS5HDo5sL%2B7kr0jwKgt5d%2FD%2FjZ6NDzywDZjfaGeG7h%2BSO9ZaCg4zOi%20%2F5bmjfbm%2B450ZJcFUMKr12%2FevH33%2FsM%2Ff3j%2F8e2nN69PPisQhUxe7vUaant%2BOHLXCBje8cmb9%2F%2FM%205v27t%2F%2FWh1f%2Fi%2F6Tm7MyOuxSGPb3XtqJDRTw%2Bc27GevBtPLwKvrPb8vD8e7e42u%2BJj37e3fsmhFQ%20xKuZTwiX14a3rz9H%2F4zWPHwx2n20d7R%2Fpjw8e36092h39MLnIqCUASrCL%2B%2FenOg4AKR1%2FH%2FDVYSf%20Pr5xZgBI6PjN4BVBYQDI6dWnUiXhu3evfUoCSOLz27Il4fuBQV0ASOBzzwuo6gJAe4r1EqZ6exL9%20ewG41MnwN46u8f6N8TaAKh0vopkw5bjgOhJAfV6HlIRT73xFAqjL8cIazNN8fB39%2BwH47SSyJJx6%2077QAUIvFXjqazkckgDqEfjr67a2bSADxoovBb5%2BiQwGw9KIrwVlaCwCxouvABQ4LAIGii8AfHBYA%20wkSXgGkcFgBiLHzZ0Uze2Z8KEOBjdPq%2FxHv7kAAWrpL5hGm%2BRMcGYNnUMMd8qTfR0QFYLl%2Bi8%2F7V%20tJsBFuhVdNa%2FzrvoCAEskVqbzL%2B9jw4RwNL4FJ3yZxEdJIAlEffOWicGFgAWoPqGwk%2FRgQJYBm%2Bj%20k72qAFCNym%2BjnvUxOlYAzatz5dF05hUAyqp6lPkPZpsBSvocneY7eh0dMICW1T%2B2doFndwCKSTKi%20cJZxBYBS0h0UrEECKCbRddTfNJsBykh4UPjHozsAZZxEp%2FeeXkUHDqBFOQ8KJpsBSsh6UNBWACjg%20XXRu78%2B0AsDA0qzMnsJDbAADy7X16IK30dEDaEx0Xp%2BPJUgAQ0q44eIc6y4ABpS4zfyNdRcAw8nc%20Zv7u%2F6JDCNCO1G3m7z5HxxCgGR%2BiU%2Fr83EsFGEjeaeYzDDYDDONtdEIfhMFmgEE08PXoHx%2BQAIbR%20xNejf3xAAhhEA3ePvvO0AsD82vh69I8dSAAD%2BBydy4ej1wwwr2a%2BHuk1A8zvfXQqH5BtFwDzOY5O%205IOyLhVgLl%2Bi8%2FigPkWHEyC3hloKp1xLBZhHSy2Ff1xLBZhPdBYfmmupAP01NKXw3cfoiAIklv11%205j%2B9jg4pQF7ZX2f%2Bkwk2gN6iU3gBugoAfUVn8ALeRccUIKu25pl%2FcFQA6KeVB3bOMasA0E97l49O%20GWsG6OVTdP4uwlEBoJf2bqR%2BEx1WgJyaeYrzPK1mgD6is3chvh8B9NDkjdRT0YEFyOhVdPIuxQIk%20gO6aHFM45fsRQHdtvcV5lseaATprc3bt1Jfo0ALk09gDzWf4fgTQ2dvo3F3Mh%2BjQAuTT6EDzKfuP%20ALp6H526y3EpFaCrRrdcnPLUDkBX0Zm7pOjYAqQTnbhL0lQA6Cg6cZdkUgGgo%2BjEXdKb6OACZBOd%20uEvSaQboKDpxl2R8DaCj6MRdVHRwAbKJzttFuX4E0E103i7K9SOAbqLzdlEWXQB00uwTzYoCQHeK%20AgC%2FtF0UTK8BdBOdtxUFgIpE521FAaAi0Xm7qE%2FR0QVIJjpvKwoAFWn4Oc5%2F%2FnkbHV2AZBQFAH55%20F524S%2FL5CKCbt9GJuyS3jwC6%2BRSduBUFgHq8iU7cJVlzAdDN6%2BjErSgA1KPponASHV2AZD5HJ25F%20AaAeTa9J%2FRwdXYBsohN3ScfRwQXIJjpxKwoAFWl5z0V0bAHSaXmkOTq2AOk0PL32ITq2AOk0PKjw%20MTq2AOk0PKiQf3P2yupo9%2FBoZ3%2Ft4OvXrwdr%2Bzvbu%2BNJ9B8FNK3hQYXU%2B%2FC2DnfWvk63tj1SGYBS%20olN3OWlXH0029r9e4%2BBoK%2FqvBNoUnbrLybnlYnR4cF1F%2BGFn14EBGFy7b68l3HKxuzNjQfhZF5wX%20gIG1eyc120Dz5LBbRfjuaBT9dwNNaff6UXRku1nd7lMSvvUXdqP%2FdqAl0bm7lPfRge1i1PG7kbIA%20lPIhOnsX8i46sLPbuva2kbIALEqr24%2ByjCmsbMx63ehKa3rOwCBaXXTxJTqws9kdoiJ8s6%2FlDAzg%20VXT2LuRVdGBnsTr3h6Ozjlajfw%2FQgOjsXUh0WGfR6xLqVTaifxGQX6Pv7ESH9XqjtfmrwB%2FfkBwW%20gDm12Wmuf3F278GEq7mHBMynzU5z7ZePtga5czTNjpVIwFyi83cRda%2FDmxyVKgn%2FOnANCZhHk02F%206KBeabh7qNPpNwNzaHEnXtVLLgp1E844iv6JQGItTipU%2FBbnZNDZhEusjaN%2FJpBXdAYvoN555tEC%20SsIpay%2BAvhq8lFrtPPPGgmrC16%2BH0T8VyOpLdAofXnRIL1Py1tFFGgtAP8fRKXxwte7NLjDDfIX9%206J8LJPUxOokPrc7RtdWFloRT0b8YyKm5oebP0RGdpvR0gqoADOR%2F0Ul8YFVOKZSfTlAVgIE0dv%2Bo%20xq9Hc73CrCoAC%2FU5Oo0Pq8ILqYu8dnTeSvRPBxJqav9RhV%2BP4mrC16%2B2pgKdNdVqru%2FrUUw%2F4afo%20Xw%2Fk01SrubqvR7E1QVUAumuo1Vzd16PBn2JWFYDSGmo1v46O5QXxNeHrQXQMgHTeRefywVT29Whx%20K%2FCuYOMF0NFJdC4fSmVPKVRRE2zHAzprpatQ1%2BvMldQEVQHoqpGuwsfoOJ4Tse%2FoEtvRsQCSaeOo%20UFWbeRxdCc7ajY4GkEsTbzV%2FiI7iOdF14DzvNgOdtHBUqGqaOboKXHBgDRLQRQtHhePoIJ6x2HfW%20ZrATHREglzfRKX1un6JDeEb0cospDqNjAuSSfllqRQeFii4e%2FbYVHRUglewTbBV1FEbR%2BX%2B61ei4%20AKl8ik7rc6loFV5Vl1HPWIsODJDLh%2BjEPo96hpkn0cn%2FUmbYgC6%2BRCf2OVS09Wg%2FOvdfbhQdGyCV%20xMMK9axH3YnO%2FFewRhvo4jg6tfdWT5e5wsuoZ1iNB3SR9QZSPV3mrei0fw33UoEuXken936q6TJP%20nkZn%2FetMokMEpJLyXmo9H49qbih85wMS0EnCpznfRcfsl2qe1bmCLdpAF8f51l1Uc%2FOo1qm183xA%20ArpI9wpbPU%2FrVLcadSofkIBOks2w1bMc9Sg63c%2FICBvQSaorSPXcRq1yNeo0%2B9GRApLJ9LbC5%2Bhg%20%2FbQanetntxEdKyCZPPsu6mkoVLzy6A96zUA3WS6m1jOhcBid6LuwLhXoKMfF1Hp2o9a%2B3uKCcXS8%20gGwyPK5QT5P5xkF0mu9GrxnoKsFZITpEv9W9G3UKc81AV9V3m6MD9FuOUeazvKwAdFb5zdTo8JyR%206ebRD44KQGdVT7FFB%2BeMNGNrZzgqAN3V%2B%2BhORT3mG5PoBN%2BLowLQXa1VoZ5t2TcSdpm%2FcVQAenj1%20MTr%2FT1PPfMK%2FRtHpvSdHBaCPCtvN9SxGPZWwy%2FyNowLQS3WfkOrZd3Qqw2tr0zkqAL0cV7UJ6X01%20e1G%2Fydll%2FsZRAeiporupVbUTbuR5WWearejgAVl9rqXfXNeno3SL8M6zAQnorYp%2Bc2Wfjm5keZb5%20MpalAr29iu8s1PN6wk95u8zfeFcBmENwZ%2BFjdceEGzeeRqf1OUXHD0jtOHJxam3dhFOpnlubxq1U%20YC4nUQ3nt8fRP32KxNdRf1iLDiGQ3UnE4zvvT6J%2F9lQ5lx6do9UMzOv1osvC%2Bxq%2FHP1rNTqjD%2BAo%20OohAAxbacf5QaUnIPbf2yyQ6ikAL3izstFBtSUj4Buc0Ws3AIL4sZGyhvsmE3x5H5%2FNB7ESHEWjF%2050%2BFK8LHek8JN%2FI%2Bo3BRdByBdvyvZM%2F5bYWzamdlfUbholF0IIGWfC7TXXj%2Fpsa5hLNSb8I7y6oL%20YFivBq8Lb%2BscSzgn9ya8M7yqAAzu1f8NN%2BmcoSLcuLEbncuHsxodS6BFx6%2BHuI6UoyLcaOig8PXr%20RnQsgVadfPrQvx58ePv6VfQPmFkrV49OeWoHKOf45M3b7i2G929Oam8sn7cTncmHZKgZKGz20vD%2B%20XbZ6cKqNYeafPNUMLMarf2vDx8uKwds3r7%2Fk%2BV50XhNbj37Ziw4nsGyOj1%2BdnLz%2BcnJy8vnVq%2BN8%20J4ML8r%2BjcI5HFQDmkf7BtQui4wmQWnQSH5qXdgD6a2hw7TuTCgD9NTS49p312QC9tTS49kN0SAHy%20ampw7TvjawA9tTW49p3xNYCe9qIzeAGH0UEFyOogOoMXoNMM0E%2BDbWYP7QD0tR2dwIuIjipAUtHp%20u4yV6LACpNTk1yOLLgD6aWtp9i%2B70XEFSCk6exeyHR1XgIy2orN3Ie6kAvTQ6Ncjd1IB%2BohO3sVE%20BxYgoUbvHikKAH20ObmmKAD00uLeI0UBoJ8Wt2YrCgA9PYpO3YoCQD0afHNNUQDoKzpzF2QjHkBH%20q9GZuyCvNAN0tBuduRUFgHq0uuNCUQDood0pBY1mgM6iE7eiAFCPlvvMigJARy33ma3OBuio3W14%20X7%2BuRQcXIJv96Mxd0H50cAGyiU7cJR1FBxcgm%2BjEXdJ2dHABkmn68tFGdHQBkmn3Kc5%2F7UZHFyCZ%20lm%2Bkfl2Nji5AMofRibuk6OACZNPyOjxjCgAdtTym4PIRQEct70jVZwboKDpxl6TPDNBRdOIuKTq2%20AOlEJ%2B6C9JkBuorO3AXtRccWIJ3ozF3QVnRsAdKJztwFRYcWIJ%2FozF2OxxQAOotO3eWYUgDorN3h%20tZXo0ALk0%2ByaCxdSAbprdiHeo%2BjIAiS0EZ28S7HjAqC7rejkXchBdGABMhpHZ%2B9CrM0G6GESnb0L%20eREdWICUorN3GTvRYQXIKTp9lzGODitATjvR%2BbsEBwWAfpq8kzqKjipAUi%2BiE3gBduEB9BWdwQvw%20kgJAX%2B1tP7L2CKC3w%2BgcPjhLswF6a27RhYMCQH8Po5P40Fw9AphDY5MKth4BzGM3Oo0P6sCLawDz%20aGsnnuuoAPNp6fvRUXQwAbJr6fvRJDqYANk19P1oIzqWAPk18%2F3I0iOA%2BY2ik%2FlQPKMAMIBG9h%2FZ%20bwEwhDZWXRxGhxGgEWvRCX0AnlsDGEgDt1IPomMI0I78RwUTCgCDSX9UsBsVYEDJZxVMrQEMaRyd%201udi5RHAsDI%2Fy6kmAAwtb6%2FZtyOAwaVddmGQGaCAo%2BjsriYAVCTlByQ1AaCMhDeQDswnAJSyEZ3j%20u9o3xwxQTrK2wnZ0vACatnIQnee7cBUVoKxEbYU176wBlJZmWsGTOgALkKMquHUEsBgZviBZdgSw%20KKvRKf86B1vRIQJYIpPorH81F1EBFms%2FOvFfzqUjgIWr9nUFswkAAep8tHnbWguAEKP6hpuPVqOD%20ArC0VipbhLSjmQAQaauiw8KOaTWAYNUcFo6cEgAqUMVhYVsvAaAS0Q%2FvHBy6cQRQj8l2YEk40koA%20qMx4J6Yi7O%2BuRP90AP40WnxZODjUSQCo1epiPyL5bARQt8nGom4i7ViNDZDAVvm5hYPtLY0EgCy2%20SnYXdnb1EQByWdktUhf2D00tA%2BQ02h60v3Cwra8MkNpkmAPD2tHGSBMBoAWTre21%2FseDf8uBDRYA%20jRlvbO93%2B5h0sHOoHAC0bGV1a2N75%2BrqcLC%2FvbG16mMRwBKZrI5HWxuH20c7R0fbh4cbG7tbo7FS%20AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA%20AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA%20AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA%20AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVfp%2Fo9Q1S6t4x5wAAAAldEVYdGRhdGU6Y3Jl%20YXRlADIwMTktMDUtMzBUMTg6MDE6MzYrMDM6MDBuJg8jAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE5%20LTA1LTMwVDE4OjAxOjM2KzAzOjAwH3u3nwAAABh0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMS42%20%2FU4J6AAAAABJRU5ErkJggg%3D%3D%22%20width%3D%221556%22%20height%3D%22849%22%2F%3E%3C%2Fsvg%3E";

},{}],"7bE3F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVersion", ()=>getVersion);
function getVersion() {
    return "2.3.7";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OcMv"}]},["cjbOo"], "cjbOo", "parcelRequireee2e", {})

//# sourceMappingURL=main.4da50c0f.js.map
